(function ()
{
    'use strict';

    angular
            .module('app.error.e500', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.error500', {
            url: '/error500',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.error500': {
                    templateUrl: 'app/main/auth/errores/500/error-500.html',
                    controller: 'MyError500Controller as vm'
                }
            },
            bodyClass: 'error500'
        });
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.error.e500')
            .controller('MyError500Controller', Error500Controller);

    /** @ngInject */
    function Error500Controller($scope, $location, ApiService, $interval)
    {
        $scope.tryingReturn = false;
        $scope.error = false;

        ApiService.serverOn().then(function () {
            $scope.tryingReturn = false;
            $scope.error = false;
            $location.path('/');
        }, function () {
            $scope.tryingReturn = false;
            $scope.error = true;
        });

        $scope.goHome = function () {
            $scope.tryingReturn = true;
            $scope.error = false;

            setTimeout(function () {
                ApiService.serverOn().then(function () {
                    $scope.tryingReturn = false;
                    $scope.error = false;
                    $location.path('/');
                }, function () {
                    $scope.tryingReturn = false;
                    $scope.error = true;
                });
            }, 1000);
        };

        var int = $interval($scope.goHome, 5000);

        $scope.$on('$destroy', function ()
        {
            $interval.cancel(int);
        });
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.error.e404', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.error404', {
            url: '/error404',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.error404': {
                    templateUrl: 'app/main/auth/errores/404/error-404.html',
                    controller: 'MyError404Controller as vm'
                }
            },
            bodyClass: 'error404'
        });
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.error.e404')
            .controller('MyError404Controller', Error404Controller);

    /** @ngInject */
    function Error404Controller($scope, $location)
    {
        $scope.goHome = function () {
            $location.path('/');
        };
    }
})();
(function ()
{
    'use strict';

    angular
            .module('app.login', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.login', {
            url: '/login',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.login': {
                    templateUrl: 'app/main/auth/login/login.html',
                    controller: 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.login')
            .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($location, ApiService, $rootScope, $cookies, configInstalacion)
    {
        var vm = this;

        vm.logoEstablecimiento = configInstalacion.logoEstablecimiento;

        vm.loggedSuccesfully = false;

        vm.login = function () {
            vm.dataLoading = true;

            var jsonObj = angular.toJson(vm.user, 0);

            ApiService.loginUsuario(jsonObj).then(function (dataResponse) {
                vm.loggedSuccesfully = true;

                $rootScope.user = dataResponse.data;

                var cookieExpireTime = new Date();
                cookieExpireTime.setDate(cookieExpireTime.getDate() + 1);
                $cookies.put('user', $rootScope.user.idUser, {expires: cookieExpireTime});
                $location.path('/');
                vm.dataLoading = false;
            }, function (dataResponse) {
                switch (dataResponse.status) {
                    case 401:
                        vm.mensajeError = 'La contraseña no es correcta';
                        break;
                    case 404:
                        vm.mensajeError = 'El usuario no existe';
                        break;
                    default:
                        vm.mensajeError = 'Error al identificar';
                }
                vm.dataLoading = false;
            });
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',
                'infinite-scroll',
                'angularTrix'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                loadMore: '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element('#content');
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msStepper', msStepperDirective)
        .directive('msStepperStep', msStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            })
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            // Hide all steps
            for ( var i = 0; i < vm.steps.length; i++ )
            {
                vm.steps[i].element.hide();
            }

            // Show the current step
            vm.steps[vm.currentStepNumber - 1].element.show();
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            vm.setCurrentStep(vm.currentStepNumber - 1);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            vm.setCurrentStep(vm.currentStepNumber + 1);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msStepperDirective()
    {
        return {
            restrict        : 'A',
            require         : ['form', 'msStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        }
    }

    /** @ngInject */
    function msStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : true,
            templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile    : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    var expanderEl,
                        collapserEl;

                    // Initialize
                    init();

                    function init()
                    {
                        expanderEl = iElement.find('#ms-search-bar-expander');
                        collapserEl = iElement.find('#ms-search-bar-collapser');

                        expanderEl.on('click', expand);
                        collapserEl.on('click', collapse);
                    }

                    /**
                     * Expand
                     */
                    function expand()
                    {
                        iElement.addClass('expanded');

                        // Esc key event
                        $document.on('keyup', escKeyEvent);
                    }

                    /**
                     * Collapse
                     */
                    function collapse()
                    {
                        iElement.removeClass('expanded');
                    }

                    /**
                     * Escape key event
                     *
                     * @param e
                     */
                    function escKeyEvent(e)
                    {
                        if ( e.keyCode === 27 )
                        {
                            collapse();
                            $document.off('keyup', escKeyEvent);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPicker($mdMenu, $mdColorPalette, fuseGenerator)
    {
        return {
            require    : 'ngModel',
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function ($scope, element, attrs, ngModel)
            {
                // Material Color Palette
                $scope.palettes = $mdColorPalette;
                $scope.selectedPalette = false;
                $scope.selectedHues = false;

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                $scope.msModelType = $scope.msModelType || 'class';

                /**
                 * Initialize / Watch model changes
                 */
                $scope.$watch('ngModel', setSelectedColor);

                /**
                 * Activate Hue Selection
                 * @param palette
                 * @param hues
                 */
                $scope.activateHueSelection = function (palette, hues)
                {
                    $scope.selectedPalette = palette;
                    $scope.selectedHues = hues;
                };

                /**
                 * Select Color
                 * @type {selectColor}
                 */
                $scope.selectColor = function (palette, hue)
                {
                    // Update Selected Color
                    updateSelectedColor(palette, hue);

                    // Update Model Value
                    updateModel();

                    // Hide The picker
                    $mdMenu.hide();
                };

                $scope.removeColor = function ()
                {

                    $scope.selectedColor = {
                        palette: '',
                        hue    : '',
                        class  : ''
                    };

                    $scope.activateHueSelection(false, false);

                    updateModel();
                };

                /**
                 * Set SelectedColor by model type
                 */
                function setSelectedColor()
                {
                    if ( !ngModel.$viewValue || ngModel.$viewValue === '' )
                    {
                        return;
                    }

                    var palette, hue;

                    // If ModelType Class
                    if ( $scope.msModelType === 'class' )
                    {
                        var color = ngModel.$viewValue.split('-');
                        if ( color.length >= 5 )
                        {
                            palette = color[1] + '-' + color[2];
                            hue = color[3];
                        }
                        else
                        {
                            palette = color[1];
                            hue = color[2];
                        }
                    }
                    // If ModelType Object
                    else if ( $scope.msModelType === 'obj' )
                    {
                        palette = ngModel.$viewValue.palette;
                        hue = ngModel.$viewValue.hue || 500;
                    }

                    // Update Selected Color
                    updateSelectedColor(palette, hue);
                }


                /**
                 * Update Selected Color
                 * @param palette
                 * @param hue
                 */
                function updateSelectedColor(palette, hue)
                {
                    $scope.selectedColor = {
                        palette     : palette,
                        hue         : hue,
                        class       : 'md-' + palette + '-' + hue + '-bg',
                        bgColorValue: fuseGenerator.rgba($scope.palettes[palette][hue].value),
                        fgColorValue: fuseGenerator.rgba($scope.palettes[palette][hue].contrast)
                    };

                    // If Model object not Equals the selectedColor update it
                    // it can be happen when the model only have pallete and hue values
                    if ( $scope.msModelType === 'obj' && !angular.equals($scope.selectedColor, ngModel.$viewValue) )
                    {
                        // Update Model Value
                        updateModel();
                    }

                    $scope.activateHueSelection(palette, $scope.palettes[palette]);
                }

                /**
                 * Update Model Value by model type
                 */
                function updateModel()
                {
                    if ( $scope.msModelType === 'class' )
                    {
                        ngModel.$setViewValue($scope.selectedColor.class);
                    }
                    else if ( $scope.msModelType === 'obj' )
                    {
                        ngModel.$setViewValue($scope.selectedColor);
                    }
                }
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem           : saveItem,
                deleteItem         : deleteItem,
                sort               : sortByWeight,
                clearNavigation    : clearNavigation,
                setActiveItem      : setActiveItem,
                getActiveItem      : getActiveItem,
                getNavigationObject: getNavigationObject,
                setNavigationScope : setNavigationScope,
                setFolded          : setFolded,
                getFolded          : getFolded,
                setFoldedOpen      : setFoldedOpen,
                getFoldedOpen      : getFoldedOpen,
                toggleFolded       : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = [];
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation object
             *
             * @param root
             * @returns {Array}
             */
            function getNavigationObject(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }
                }

                return navigation;
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigationObject($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigationObject();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();

                        // If navigation is folded open, close it
                        if ( msNavigationService.getFolded() )
                        {
                            onFoldCollapserHover();
                        }
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states everything except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    })
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        }

    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
            .module('app.usuarios', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider, msApiProvider)
    {
        // State
        $stateProvider
                .state('app.usuarios', {
                    url: '/usuarios',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/usuarios/usuarios.html',
                            controller: 'UsuariosController as vm'
                        }
                    }
                });

        msNavigationServiceProvider.saveItem('usuarios', {
            title: 'Usuarios',
            icon: 'icon-account-multiple',
            state: 'app.usuarios',
            weight: 3
        });
    }
})();
(function ()
{
    'use strict';

    angular
            .module('app.usuarios')
            .controller('UsuariosController', UsuariosController);

    /** @ngInject */
    function UsuariosController(ApiService, $scope, $mdDialog, $rootScope, $cookies, msApi, $mdToast, $filter)
    {
        var vm = this;
        
        vm.CargarUsuarios = function () {
            $rootScope.loadingRequest = true;

            ApiService.getUsuarios().then(function (dataResponse) {
                vm.listaUsuarios = dataResponse.data;
                $rootScope.loadingRequest = false;
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Error al obtener los datos').position('top right')
                        .theme('error').hideDelay(5000));
                $rootScope.loadingRequest = false;
            });
        };
        vm.CargarUsuarios();

        $scope.addUsuario = function () {
            $mdDialog.show({
                controller: NuevoCtrl,
                templateUrl: 'app/main/usuarios/templates/crearUsuario.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                onComplete: function () {
                    document.getElementById('uploadImage').addEventListener('change', cargarArchivo, false);

                    function cargarArchivo(evt) {
                        var file = evt.target.files[0];
                        if (file) {
                            var oFReader = new FileReader();
                            oFReader.readAsDataURL(file);

                            oFReader.onload = function (oFREvent) {
                                document.getElementById("uploadPreview").src = oFREvent.target.result;
                                angular.element($('#editarUsuario')).scope().file = file;
                            };
                        } else {
                            document.getElementById("uploadPreview").src = "assets/resources/user.png";
                        }
                    }
                }
            });
        };

        function NuevoCtrl($scope, $mdDialog) {
            $scope.noImageUrl = '/assets/resources/noImage.png';

            $scope.listaLang = vm.variables.languages;
            $scope.listaTeams = vm.variables.teams;

            $scope.usuario = {};

            $scope.toggleStar = function () {
                if ($scope.usuario.userRole === 'ROOT')
                    $scope.usuario.userRole = 'ADMINISTRATOR';
                else
                    $scope.usuario.userRole = 'ROOT';
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;
                var jsonObj = angular.toJson($scope.usuario, 0);

                ApiService.addUsuario(jsonObj).then(function (dataResponse) {
                    var file = $scope.file;

                    if (file) {
                        $mdToast.show($mdToast.simple().textContent('Usuario añadido correctamente. Subiendo imagen de perfil...').position('top right')
                                .theme('success').hideDelay(3000));

                        var formData = new FormData();
                        formData.append('file', file);
                        var extension = '.' + file.type.split('/')[1];

                        ApiService.uploadFile(formData, (dataResponse.data.idUser + extension), '/profile').then(function () {
                            var u = dataResponse.data;
                            u.img = 'https://users.solertia-hospitality.com/avatars/profile/' + u.idUser + extension + '?v=' + (+new Date());

                            ApiService.updateUsuario(u.idUser, angular.toJson(u)).then(function () {
                                $mdToast.show($mdToast.simple().textContent('Imagen subida correctamente').position('top right')
                                        .theme('success').hideDelay(3000));

                                vm.CargarUsuarios();
                                $scope.hide();
                                editRoles(dataResponse.data);
                            }, function () {
                                vm.CargarUsuarios();
                                $scope.hide();
                                editRoles(dataResponse.data);
                            });
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Error al subir la imagen de perfil').position('top right')
                                    .theme('error').hideDelay(5000));
                            vm.CargarUsuarios();
                            $scope.hide();
                            editRoles(dataResponse.data);
                        });
                    } else {
                        $mdToast.show($mdToast.simple().textContent('Usuario añadido correctamente').position('top right')
                                .theme('success').hideDelay(3000));
                        vm.CargarUsuarios();
                        $scope.hide();
                        editRoles(dataResponse.data);
                    }
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al guardar usuario').position('top right')
                            .theme('error').hideDelay(5000));
                    $scope.dataLoading = false;
                });
            };
        }

        $scope.editar = function (usuario) {
            $mdDialog.show({
                controller: EditarCtrl,
                templateUrl: 'app/main/usuarios/templates/editarUsuario.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    usuario: usuario
                },
                onComplete: function () {
                    document.getElementById('uploadImage').addEventListener('change', cargarArchivo, false);

                    function cargarArchivo(evt) {
                        var file = evt.target.files[0];
                        if (file) {
                            var oFReader = new FileReader();
                            oFReader.readAsDataURL(file);

                            oFReader.onload = function (oFREvent) {
                                document.getElementById("uploadPreview").src = oFREvent.target.result;
                                angular.element($('#editarUsuario')).scope().file = file;
                            };
                        } else {
                            document.getElementById("uploadPreview").src = "assets/resources/user.png";
                        }
                    }
                }
            });
        };

        function EditarCtrl($scope, $mdDialog, usuario) {
            $scope.noImageUrl = '/assets/resources/noImage.png';
            $scope.usuario = angular.copy(usuario);

            $scope.listaLang = vm.variables.languages;
            $scope.listaTeams = vm.variables.teams;

            $scope.toggleStar = function () {
                if ($scope.usuario.userRole === 'ROOT')
                    $scope.usuario.userRole = 'ADMINISTRATOR';
                else
                    $scope.usuario.userRole = 'ROOT';
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;
                $scope.error = '';

                if ($scope.changePass && (!$scope.password.old || !$scope.password.new1 || !$scope.password.new2)) {
                    $scope.error = 'Faltan datos';
                    $scope.dataLoading = false;
                    return;
                }

                if ($scope.changePass && ($scope.password.new1 !== $scope.password.new2)) {
                    $scope.error = 'Los campos de nueva contraseña no coinciden';
                    $scope.dataLoading = false;
                    return;
                }

                var file = $scope.file;

                if (file) {
                    var formData = new FormData();
                    formData.append('file', file);
                    var extension = '.' + file.type.split('/')[1];
                    $scope.usuario.img = 'https://users.solertia-hospitality.com/avatars/profile/' + usuario.idUser + extension + '?v=' + (+new Date());

                    ApiService.uploadFile(formData, (usuario.idUser + extension), '/profile').then(function (dataResponse) {
                        $mdToast.show($mdToast.simple().textContent('Imagen de perfil subida correctamente. Guardando usuario...').position('top right')
                                .theme('success').hideDelay(3000));
                        ss();
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Error al subir la imagen de perfil. Guardando usuario...').position('top right')
                                .theme('error').hideDelay(3000));
                        ss();
                    });
                } else {
                    ss();
                }

                function ss() {
                    var copy = angular.copy($scope.usuario);
                    delete copy.lastModified;
                    var jsonObj = angular.toJson(copy);

                    ApiService.updateUsuario(usuario.idUser, jsonObj).then(function (dataResponse) {
                        if ($scope.changePass) {
                            ApiService.updatePasswordUsuario(usuario.idUser, $scope.password.old, $scope.password.new1).then(function () {
                                $mdToast.show($mdToast.simple().textContent('Usuario modificado correctamente').position('top right')
                                        .theme('success').hideDelay(3000));

                                if (parseInt($cookies.get('user')) === dataResponse.data.idUser)
                                    location.reload();

                                vm.CargarUsuarios();
                                $scope.hide();
                            }, function (dataResponse) {
                                $scope.dataLoading = false;
                                switch (dataResponse.status) {
                                    case 400:
                                        $scope.error = 'La contraseña actual no es correcta';
                                }
                            });
                        } else {
                            if (parseInt($cookies.get('user')) === dataResponse.data.idUser)
                                location.reload();

                            $mdToast.show($mdToast.simple().textContent('Usuario modificado correctamente').position('top right')
                                    .theme('success').hideDelay(3000));

                            vm.CargarUsuarios();
                            $scope.hide();
                        }
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Error al guardar usuario').position('top right')
                                .theme('error').hideDelay(5000));
                        $scope.dataLoading = false;
                    });
                }
            };
        }

        $scope.eliminar = function (usuario) {
            var confirm = $mdDialog.confirm()
                    .title('¿Eliminar usuario?')
                    .ok('Eliminar')
                    .cancel('Cerrar');

            $mdDialog.show(confirm).then(function () {
                $mdToast.show($mdToast.simple().textContent('Eliminando...').position('top right')
                        .hideDelay(3000));

                ApiService.deleteUsuario(usuario.idUser).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent('Usuario eliminado correctamente. Borrando imagen de perfil del servidor...').position('top right')
                            .theme('success').hideDelay(3000));

                    vm.CargarUsuarios();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al eliminar usuario').position('top right')
                            .theme('error').hideDelay(5000));
                });
            });
        };

        //******************* Roles **************************
        vm.CargarRoles = function () {
            ApiService.getRoles().then(function (dataResponse) {
                vm.listaRoles = $filter('orderBy')(dataResponse.data, '-priority');
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Error al obtener la lista de roles').position('top right')
                        .theme('error').hideDelay(5000));
            });
        };
//        vm.CargarRoles();

        //******************* Places **************************
        vm.CargarPlaces = function () {
            ApiService.getPlaces().then(function (dataResponse) {
                vm.listaPlaces = $filter('orderBy')(dataResponse.data, 'name');
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Error al obtener la lista de instalaciones').position('top right')
                        .theme('error').hideDelay(5000));
            });
        };
//        vm.CargarPlaces();

        //Eventos de scroll
        $('#content').ready(function () {
            $('#content').bind('scroll', chk_top);
        });

        function chk_top(e) {
            var elem = $(e.currentTarget);
            $rootScope.showGoToUpButton = (elem.scrollTop() > 0);
            $rootScope.$apply();
        }
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.places', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
                .state('app.places', {
                    url: '/places',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/places/places.html',
                            controller: 'PlacesController as vm'
                        }
                    }
                });

        msNavigationServiceProvider.saveItem('places', {
            title: 'Instalaciones',
            icon: 'icon-map-marker-radius',
            state: 'app.places',
            weight: 2
        });
    }
})();
(function ()
{
    'use strict';

    angular
            .module('app.places')
            .controller('PlacesController', PlacesController);

    /** @ngInject */
    function PlacesController(ApiService, $scope, $mdDialog, $rootScope, $filter, $mdToast)
    {
        var vm = this;

        //******************* Places **************************
        vm.CargarPlaces = function () {
            $rootScope.loadingRequest = true;

            ApiService.getPlaces().then(function (dataResponse) {
                vm.listaPlaces = dataResponse.data.map(function (e) {
                    e.lastModifiedFormat = $filter('date')(new Date(e.lastModified), 'dd/MM/yyyy HH:mm');
                    e.lastSyncFormat = $filter('date')(new Date(e.lastSync), 'dd/MM/yyyy HH:mm');
                    e.synchronized = +new Date(e.lastModified) < +new Date(e.lastSync);
                    return e;
                });

                $rootScope.loadingRequest = false;
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Error al obtener los datos').position('top right')
                        .theme('error').hideDelay(5000));
                $rootScope.loadingRequest = false;
            });
        };
        vm.CargarPlaces();

        $scope.addPlace = function () {
            $mdDialog.show({
                controller: NuevoPCtrl,
                templateUrl: 'app/main/places/templates/crearPlace.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true
            });
        };

        function NuevoPCtrl($scope, $mdDialog) {
            $scope.DialogTitle = "Registrar instalación";

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;
                var jsonObj = angular.toJson($scope.place, 0);

                ApiService.addPlace(jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent('Instalación añadida correctamente').position('top right')
                            .theme('success').hideDelay(3000));

                    vm.CargarPlaces();
                    $scope.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al guardar').position('top right')
                            .theme('error').hideDelay(5000));
                    $scope.dataLoading = false;
                });
            };
        }

        $scope.editarPlace = function (place) {
            $mdDialog.show({
                controller: EditarCtrl,
                templateUrl: 'app/main/places/templates/crearPlace.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    place: place
                }
            });
        };

        function EditarCtrl($scope, $mdDialog, place) {
            $scope.DialogTitle = "Editar instalación";
            $scope.place = angular.copy(place);

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var jsonObj = angular.toJson({
                    name: $scope.place.name,
                    dominio: $scope.place.dominio
                });

                ApiService.updatePlace(place.idPlace, jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent('Instalación modificada correctamente').position('top right')
                            .theme('success').hideDelay(3000));

                    vm.CargarPlaces();
                    $scope.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al guardar').position('top right')
                            .theme('error').hideDelay(5000));
                    $scope.dataLoading = false;
                });
            };
        }

        $scope.eliminarPlace = function (place) {
            var confirm = $mdDialog.confirm()
                    .title('¿Eliminar instalación?')
                    .ok('Eliminar')
                    .cancel('Cerrar');

            $mdDialog.show(confirm).then(function () {
                $mdToast.show($mdToast.simple().textContent('Eliminando...').position('top right')
                        .hideDelay(3000));

                ApiService.deletePlace(place.idPlace).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent('Instalación eliminada correctamente').position('top right')
                            .theme('success').hideDelay(3000));

                    vm.CargarPlaces();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al eliminar').position('top right')
                            .theme('error').hideDelay(5000));
                });
            });
        };

        $scope.sincronizar = function (place) {
            var confirm = $mdDialog.confirm()
                    .title('¿Sincronizar usuarios de la instalación?')
                    .textContent('Se sobreescribirán los usuarios de la instalación.')
                    .ok('Aceptar')
                    .cancel('Cancelar');

            $mdDialog.show(confirm).then(function () {
                $mdToast.show($mdToast.simple().textContent('Enviando sincronización...').position('top right')
                        .hideDelay(3000));

                ApiService.syncPlaceExtern(place.dominio).then(function (dataResponse) {
                    $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('Sincronización enviada')
                            .ariaLabel('Sincronización').ok('Cerrar'));

                    vm.CargarPlaces();
                }, function () {
                    ApiService.syncPlace(place.dominio).then(function (dataResponse) {
                        $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('Sincronización enviada')
                                .ariaLabel('Sincronización').ok('Cerrar'));

                        vm.CargarPlaces();
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Error al enviar sincronización').position('top right')
                                .theme('error').hideDelay(5000));
                    });
                });
            });
        };

        $scope.verUsuarios = function (place) {
            $mdDialog.show({
                controller: UsuariosCtrl,
                templateUrl: 'app/main/places/templates/verUsuarios.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    place: place
                }
            });
        };

        function UsuariosCtrl($scope, $mdDialog, place, $filter) {
            $scope.loading = true;
            $scope.place = angular.copy(place);

            ApiService.getTeamCajeros().then(function (dataResponse) {
                $scope.listaCajeros = [];

                $.each(dataResponse.data, function (key, value) {
                    var k = Object.keys(value);

                    $scope.listaCajeros.push({
                        name: k[0],
                        atms: value[k[0]]
                    });
                });

                console.log($scope.listaCajeros)

                $scope.loading = false;
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Error al obtener los datos').position('top right')
                        .theme('error').hideDelay(5000));
                $scope.loading = false;
            });

            $scope.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1)
                    list.splice(idx, 1);
                else
                    list.push(item);
            };
            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                console.log($scope.place);

                var jsonObj = angular.toJson({
                    atms: $scope.place.atms
                });

                ApiService.updatePlace(place.idPlace, jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent('Instalación modificada correctamente').position('top right')
                            .theme('success').hideDelay(3000));

                    vm.CargarPlaces();
                    $scope.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al guardar').position('top right')
                            .theme('error').hideDelay(5000));
                    $scope.dataLoading = false;
                });
            };
        }

        vm.SincronizarPendientes = function () {
            var pendientes = vm.listaPlaces.filter(function (e) {
                return !e.synchronized;
            });

            console.log(pendientes);

            var confirm = $mdDialog.confirm()
                    .title('¿Sincronizar instalaciones desactualizadas?')
                    .textContent(pendientes.map(function (e) {
                        return e.name;
                    }).join(', '))
                    .ok('Aceptar')
                    .cancel('Cerrar');

            $mdDialog.show(confirm).then(function () {
                $mdDialog.show({
                    controller: function ($scope, $mdDialog, pendientes) {
                        $scope.pendientes = pendientes;

                        $scope.loaded = {};
                        $scope.notloaded = {};
                        $.each($scope.pendientes, function (index, place) {
                            ApiService.syncPlaceExtern(place.dominio).then(function (dataResponse) {
                                $scope.loaded[place.dominio] = true;

                                if ((Object.keys($scope.loaded).length + Object.keys($scope.notloaded).length) >= pendientes.length) {
                                    vm.CargarPlaces();
                                    $mdDialog.hide();
                                }
                            }, function () {
                                ApiService.syncPlace(place.dominio).then(function (dataResponse) {
                                    $scope.loaded[place.dominio] = true;

                                    if ((Object.keys($scope.loaded).length + Object.keys($scope.notloaded).length) >= pendientes.length) {
                                        vm.CargarPlaces();
                                        $mdDialog.hide();
                                    }
                                }, function () {
                                    $mdToast.show($mdToast.simple().textContent('Error al enviar sincronización').position('top right')
                                            .theme('error').hideDelay(5000));

                                    $scope.notloaded[place.dominio] = true;

                                    if ((Object.keys($scope.loaded).length + Object.keys($scope.notloaded).length) >= pendientes.length) {
                                        vm.CargarPlaces();
                                        $mdDialog.hide();
                                    }
                                });
                            });
                        });
                    },
                    templateUrl: 'app/main/places/templates/syncProgress.tmpl.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    locals: {
                        pendientes: pendientes
                    }
                });
            });
        };

        //Eventos de scroll
        $('#content').ready(function () {
            $('#content').bind('scroll', chk_top);
        });

        function chk_top(e) {
            var elem = $(e.currentTarget);
            $rootScope.showGoToUpButton = (elem.scrollTop() > 0);
            $rootScope.$apply();
        }
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.cajeros', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider,msApiProvider)
    {
        // State
        $stateProvider
                .state('app.cajeros', {
                    url: '/',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/cajeros/cajeros.html',
                            controller: 'CajerosController as vm'
                        }
                    }
                });

        msNavigationServiceProvider.saveItem('cajeros', {
            title: 'Cajeros',
            icon: 'icon-deskphone',
            state: 'app.cajeros',
            weight: 1
        });
    }
})();
(function ()
{
    'use strict';

    angular
            .module('app.cajeros')
            .controller('CajerosController', CajerosController);

    /** @ngInject */
    function CajerosController(ApiService, $scope, $mdDialog, $rootScope, $filter, $mdToast)
    {
        var vm = this;

        $scope.showExtendedInfo = false;

        $scope.objectKeys = function (obj) {
            try {
                return Object.keys(obj);
            } catch (e) {
                return [];
            }
        };

        //******************* Cajeros **************************
        vm.CargarCajeros = function () {
            $rootScope.loadingRequest = true;

            ApiService.getTeamCajeros().then(function (dataResponse) {
                vm.listaCajeros = [];
                vm.teamList = [];

                $.each(dataResponse.data, function (key, value) {
                    var k = Object.keys(value);

                    vm.listaCajeros.push({
                        name: k[0],
                        atms: value[k[0]]
                    });

                    vm.teamList.push(k[0]);
                });

                $rootScope.loadingRequest = false;
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Error al obtener los datos').position('top right')
                        .theme('error').hideDelay(5000));
                $rootScope.loadingRequest = false;
            });
        };
        vm.CargarCajeros();

        $scope.featureIcons = {
            "InzRfid": {icon: "icon-account-location", text: "Identificación RFID"},
            "InzCard": {icon: "icon-credit-card", text: "Pago por tarjeta"},
            "InzCash": {icon: "icon-coin", text: "Pago en efectivo"},
            "InzRc": {icon: "icon-remote", text: "Mandos"},
            "SpecialCard": {icon: 'icon-star-outline', text: "Special Card"}
        };

        $scope.addCajero = function () {
            $mdDialog.show({
                controller: NuevoCtrl,
                templateUrl: 'app/main/cajeros/templates/crearCajero.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true
            });
        };

        function NuevoCtrl($scope, $mdDialog) {
            $scope.DialogTitle = "Registrar cajero";
            $scope.cajero = {
                features: [],
                chats: [],
                team: "",
                config: "{}"
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;
                var copy = angular.copy($scope.cajero);
                var jsonObj = angular.toJson(copy);

                ApiService.addCajero(jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent('Cajero añadido correctamente').position('top right')
                            .theme('success').hideDelay(3000));

                    vm.CargarCajeros();
                    $scope.hide();

                    asignarTeam(dataResponse.data);
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al guardar').position('top right')
                            .theme('error').hideDelay(5000));
                    $scope.dataLoading = false;
                });
            };
        }

        $scope.editarCajero = function (cajero) {
            $mdDialog.show({
                controller: EditarCtrl,
                templateUrl: 'app/main/cajeros/templates/crearCajero.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    cajero: cajero
                }
            });
        };

        function EditarCtrl($scope, $mdDialog, cajero) {
            $scope.DialogTitle = "Editar cajero";
            $scope.cajero = angular.copy(cajero);

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;
                var copy = angular.copy($scope.cajero);
                copy.config = angular.toJson(copy.config);
                var jsonObj = angular.toJson(copy);

                ApiService.updateCajero(cajero.idAtm, jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent('Cajero modificado correctamente').position('top right')
                            .theme('success').hideDelay(3000));

                    vm.CargarCajeros();
                    $scope.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al guardar').position('top right')
                            .theme('error').hideDelay(5000));
                    $scope.dataLoading = false;
                });
            };
        }

        $scope.asignarTeam = asignarTeam;
        function asignarTeam(cajero) {
            $mdDialog.show({
                controller: TeamCtrl,
                templateUrl: 'app/main/cajeros/templates/asignarTeam.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    cajero: cajero
                }
            });
        }

        function TeamCtrl($scope, $mdDialog, cajero) {
            $scope.DialogTitle = "Asignar grupo";
            $scope.cajero = {team: cajero.team};

            $scope.teamList = vm.teamList;
            $scope.customTeam = '';

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;
                var copy = angular.copy($scope.cajero);

                if (copy.team === '___')
                    copy.team = $scope.customTeam;

                var jsonObj = angular.toJson(copy);

                ApiService.updateCajero(cajero.idAtm, jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent('Grupo modificado correctamente').position('top right')
                            .theme('success').hideDelay(3000));

                    vm.CargarCajeros();
                    $scope.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al guardar').position('top right')
                            .theme('error').hideDelay(5000));
                    $scope.dataLoading = false;
                });
            };
        }

        $scope.editarConfig = function (cajero) {
            $mdDialog.show({
                controller: ConfigCtrl,
                templateUrl: 'app/main/cajeros/templates/cambiarConfig.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    cajero: cajero
                }
            });
        };

        function ConfigCtrl($scope, $mdDialog, cajero) {
            $scope.DialogTitle = "Editar config";
            $scope.cajero = {config: angular.toJson(cajero.config, 5)};

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;
                var copy = angular.copy($scope.cajero);
                try {
                    copy.config = angular.toJson(angular.fromJson(copy.config), 5);
                } catch (e) {
                    $mdToast.show($mdToast.simple().textContent('El JSON no es correcto').position('top right')
                            .theme('error').hideDelay(5000));
                    $scope.dataLoading = false;
                    return;
                }
                var jsonObj = angular.toJson(copy);

                ApiService.updateCajero(cajero.idAtm, jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent('Grupo modificado correctamente').position('top right')
                            .theme('success').hideDelay(3000));

                    vm.CargarCajeros();
                    $scope.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al guardar').position('top right')
                            .theme('error').hideDelay(5000));
                    $scope.dataLoading = false;
                });
            };

            $scope.formatJson = function () {
                try {
                    $scope.cajero.config = angular.toJson(angular.fromJson($scope.cajero.config), 5);
                } catch (e) {
                    $mdToast.show($mdToast.simple().textContent('El JSON no es correcto').position('top right')
                            .theme('error').hideDelay(5000));
                }
            };
        }

        $scope.eliminarCajero = function (cajero) {
            var confirm = $mdDialog.confirm()
                    .title('¿Eliminar cajero?')
                    .ok('Eliminar')
                    .cancel('Cerrar');

            $mdDialog.show(confirm).then(function () {
                $mdToast.show($mdToast.simple().textContent('Eliminando...').position('top right')
                        .hideDelay(3000));

                ApiService.deleteCajero(cajero.idAtm).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent('Cajero eliminado correctamente').position('top right')
                            .theme('success').hideDelay(3000));

                    vm.CargarCajeros();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al eliminar').position('top right')
                            .theme('error').hideDelay(5000));
                });
            });
        };

        $scope.addDescCajero = function (cajero) {
            $mdDialog.show({
                controller: AddDescCtrl,
                templateUrl: 'app/main/cajeros/templates/descCajero.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    cajero: cajero
                }
            });
        };

        function AddDescCtrl($scope, $mdDialog, cajero) {
            $scope.DialogTitle = "Añadir descripción";

            $scope.lang = "";
            $scope.description = "";

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var copy = {
                    idAtm: cajero.idAtm,
                    description: angular.copy(cajero.description)
                };

                if (Object.keys(cajero.description).includes($scope.lang)) {
                    $mdToast.show($mdToast.simple().textContent('Ya existe una descripción en este idioma').position('top right')
                            .theme('error').hideDelay(3000));
                    $scope.dataLoading = false;
                    return;
                }

                copy.description[$scope.lang] = $scope.description;

                console.log(copy)

                var jsonObj = angular.toJson(copy);

                ApiService.updateCajero(cajero.idAtm, jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent('Cajero modificado correctamente').position('top right')
                            .theme('success').hideDelay(3000));

                    vm.CargarCajeros();
                    $scope.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al guardar').position('top right')
                            .theme('error').hideDelay(5000));
                    $scope.dataLoading = false;
                });
            };
        }

        $scope.editarDescCajero = function (cajero, lang) {
            $mdDialog.show({
                controller: EditarDescCtrl,
                templateUrl: 'app/main/cajeros/templates/descCajero.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    cajero: cajero,
                    lang: lang
                }
            });
        };

        function EditarDescCtrl($scope, $mdDialog, cajero, lang) {
            $scope.DialogTitle = "Editar descripción '" + lang.toUpperCase() + "'";

            $scope.lang = lang;
            $scope.description = cajero.description[lang];

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var copy = {
                    idAtm: cajero.idAtm,
                    description: angular.copy(cajero.description)
                };

                if (lang !== $scope.lang) {
                    if (Object.keys(cajero.description).includes($scope.lang)) {
                        $mdToast.show($mdToast.simple().textContent('Ya existe una descripción en este idioma').position('top right')
                                .theme('error').hideDelay(3000));
                        $scope.dataLoading = false;
                        return;
                    } else {
                        Object.defineProperty(copy.description, $scope.lang,
                                Object.getOwnPropertyDescriptor(copy.description, lang));
                        delete copy.description[lang];
                    }
                }

                copy.description[$scope.lang] = $scope.description;

                var jsonObj = angular.toJson(copy);

                ApiService.updateCajero(cajero.idAtm, jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent('Cajero modificado correctamente').position('top right')
                            .theme('success').hideDelay(3000));

                    vm.CargarCajeros();
                    $scope.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al guardar').position('top right')
                            .theme('error').hideDelay(5000));
                    $scope.dataLoading = false;
                });
            };
        }

        $scope.eliminarDescCajero = function (cajero, lang) {
            var confirm = $mdDialog.confirm()
                    .title("¿Eliminar descripción '" + lang.toUpperCase() + "'?")
                    .ok('Eliminar')
                    .cancel('Cerrar');

            $mdDialog.show(confirm).then(function () {
                var copy = {
                    idAtm: cajero.idAtm,
                    description: angular.copy(cajero.description)
                };

                delete copy.description[lang];

                var jsonObj = angular.toJson(copy);

                ApiService.updateCajero(cajero.idAtm, jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent('Cajero modificado correctamente').position('top right')
                            .theme('success').hideDelay(3000));

                    vm.CargarCajeros();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al guardar').position('top right')
                            .theme('error').hideDelay(5000));
                    $scope.dataLoading = false;
                });
            });
        };

        $scope.addCode = function (cajero) {
            $mdDialog.show({
                controller: AddCodeCtrl,
                templateUrl: 'app/main/cajeros/templates/codeCajero.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    cajero: cajero
                }
            });
        };

        function AddCodeCtrl($scope, $mdDialog, cajero) {
            $scope.DialogTitle = "Añadir code";

            $scope.code = {
                posibilities: []
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var copy = {
                    idAtm: cajero.idAtm,
                    codes: angular.copy(cajero.codes)
                };

                ApiService.addCode(angular.toJson($scope.code)).then(function (dataResponse) {
                    copy.codes.push(dataResponse.data)

                    console.log(copy)

                    var jsonObj = angular.toJson(copy);

                    ApiService.updateCajero(cajero.idAtm, jsonObj).then(function () {
                        $mdToast.show($mdToast.simple().textContent('Cajero modificado correctamente').position('top right')
                                .theme('success').hideDelay(3000));

                        vm.CargarCajeros();
                        $scope.hide();
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Error al guardar').position('top right')
                                .theme('error').hideDelay(5000));
                        $scope.dataLoading = false;
                    });
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al guardar code').position('top right')
                            .theme('error').hideDelay(5000));
                    $scope.dataLoading = false;
                })
            };

        }

        $scope.editarCode = function (cajero, code) {
            $mdDialog.show({
                controller: EditarCodeCtrl,
                templateUrl: 'app/main/cajeros/templates/codeCajero.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    cajero: cajero,
                    code: code
                }
            });
        };

        function EditarCodeCtrl($scope, $mdDialog, cajero, code) {
            $scope.DialogTitle = "Editar code";

            $scope.code = angular.copy(code);

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var jsonObj = angular.toJson($scope.code);

                ApiService.updateCode(code.idCode, jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent('Code modificado correctamente').position('top right')
                            .theme('success').hideDelay(3000));

                    vm.CargarCajeros();
                    $scope.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al guardar').position('top right')
                            .theme('error').hideDelay(5000));
                    $scope.dataLoading = false;
                });
            };

        }

        $scope.eliminarCode = function (cajero, code) {
            var confirm = $mdDialog.confirm()
                    .title("¿Eliminar code?")
                    .ok('Eliminar')
                    .cancel('Cerrar');

            $mdDialog.show(confirm).then(function () {
                var copy = {
                    idAtm: cajero.idAtm,
                    codes: angular.copy(cajero.codes)
                };

                var idx = cajero.codes.findIndex(function (elm) {
                    return elm.idCode === code.idCode;
                });

                copy.codes.splice(idx, 1);

                var jsonObj = angular.toJson(copy);

                ApiService.updateCajero(cajero.idAtm, jsonObj).then(function (dataResponse) {
                    ApiService.deleteCode(code.idCode).then(function (dataResponse) {
                        $mdToast.show($mdToast.simple().textContent('Code eliminado correctamente').position('top right')
                                .theme('success').hideDelay(3000));

                        vm.CargarCajeros();
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Error al eliminar code, pero se desasoció del cajero.').position('top right')
                                .theme('error').hideDelay(5000));
                        $scope.dataLoading = false;
                    });
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al guardar').position('top right')
                            .theme('error').hideDelay(5000));
                    $scope.dataLoading = false;
                });
            });
        };

        $scope.addNameCode = function (code) {
            $mdDialog.show({
                controller: AddNameCodeCtrl,
                templateUrl: 'app/main/cajeros/templates/descCode.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    code: code
                }
            });
        };

        function AddNameCodeCtrl($scope, $mdDialog, code) {
            $scope.DialogTitle = "Añadir nombre";

            $scope.lang = "";
            $scope.description = "";

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var copy = {
                    idCode: code.idCode,
                    name: angular.copy(code.name)
                };

                if (Object.keys(code.name).includes($scope.lang)) {
                    $mdToast.show($mdToast.simple().textContent('Ya existe un nombre en este idioma').position('top right')
                            .theme('error').hideDelay(3000));
                    $scope.dataLoading = false;
                    return;
                }

                copy.name[$scope.lang] = $scope.description;

                console.log(copy)

                var jsonObj = angular.toJson(copy);

                ApiService.updateCode(code.idCode, jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent('Code modificado correctamente').position('top right')
                            .theme('success').hideDelay(3000));

                    vm.CargarCajeros();
                    $scope.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al guardar').position('top right')
                            .theme('error').hideDelay(5000));
                    $scope.dataLoading = false;
                });
            };
        }

        $scope.editarNameCode = function (code, lang) {
            $mdDialog.show({
                controller: EditarNameCodeCtrl,
                templateUrl: 'app/main/cajeros/templates/descCode.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    code: code,
                    lang: lang
                }
            });
        };

        function EditarNameCodeCtrl($scope, $mdDialog, code, lang) {
            $scope.DialogTitle = "Editar nombre '" + lang.toUpperCase() + "'";

            $scope.lang = lang;
            $scope.description = code.name[lang];

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var copy = {
                    idCode: code.idCode,
                    name: angular.copy(code.name)
                };

                if (lang !== $scope.lang) {
                    if (Object.keys(code.name).includes($scope.lang)) {
                        $mdToast.show($mdToast.simple().textContent('Ya existe un nombre en este idioma').position('top right')
                                .theme('error').hideDelay(3000));
                        $scope.dataLoading = false;
                        return;
                    } else {
                        Object.defineProperty(copy.name, $scope.lang,
                                Object.getOwnPropertyDescriptor(copy.name, lang));
                        delete copy.name[lang];
                    }
                }

                copy.name[$scope.lang] = $scope.description;

                var jsonObj = angular.toJson(copy);

                ApiService.updateCode(code.idCode, jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent('Code modificado correctamente').position('top right')
                            .theme('success').hideDelay(3000));

                    vm.CargarCajeros();
                    $scope.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al guardar').position('top right')
                            .theme('error').hideDelay(5000));
                    $scope.dataLoading = false;
                });
            };
        }

        $scope.eliminarNameCode = function (code, lang) {
            var confirm = $mdDialog.confirm()
                    .title("¿Eliminar nombre '" + lang.toUpperCase() + "'?")
                    .ok('Eliminar')
                    .cancel('Cerrar');

            $mdDialog.show(confirm).then(function () {
                var copy = {
                    idCode: code.idCode,
                    name: angular.copy(code.name)
                };

                delete copy.name[lang];

                var jsonObj = angular.toJson(copy);

                ApiService.updateCode(code.idCode, jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent('Code modificado correctamente').position('top right')
                            .theme('success').hideDelay(3000));

                    vm.CargarCajeros();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al guardar').position('top right')
                            .theme('error').hideDelay(5000));
                    $scope.dataLoading = false;
                });
            });
        };

        $scope.addDescCode = function (code) {
            $mdDialog.show({
                controller: AddDescCodeCtrl,
                templateUrl: 'app/main/cajeros/templates/descCode.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    code: code
                }
            });
        };

        function AddDescCodeCtrl($scope, $mdDialog, code) {
            $scope.DialogTitle = "Añadir descripción";

            $scope.lang = "";
            $scope.description = "";

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var copy = {
                    idCode: code.idCode,
                    description: angular.copy(code.description)
                };

                if (Object.keys(code.description).includes($scope.lang)) {
                    $mdToast.show($mdToast.simple().textContent('Ya existe una descripción en este idioma').position('top right')
                            .theme('error').hideDelay(3000));
                    $scope.dataLoading = false;
                    return;
                }

                copy.description[$scope.lang] = $scope.description;

                console.log(copy)

                var jsonObj = angular.toJson(copy);

                ApiService.updateCode(code.idCode, jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent('Code modificado correctamente').position('top right')
                            .theme('success').hideDelay(3000));

                    vm.CargarCajeros();
                    $scope.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al guardar').position('top right')
                            .theme('error').hideDelay(5000));
                    $scope.dataLoading = false;
                });
            };
        }

        $scope.editarDescCode = function (code, lang) {
            $mdDialog.show({
                controller: EditarDescCodeCtrl,
                templateUrl: 'app/main/cajeros/templates/descCode.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    code: code,
                    lang: lang
                }
            });
        };

        function EditarDescCodeCtrl($scope, $mdDialog, code, lang) {
            $scope.DialogTitle = "Editar descripción '" + lang.toUpperCase() + "'";

            $scope.lang = lang;
            $scope.description = code.description[lang];

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var copy = {
                    idCode: code.idCode,
                    description: angular.copy(code.description)
                };

                if (lang !== $scope.lang) {
                    if (Object.keys(code.description).includes($scope.lang)) {
                        $mdToast.show($mdToast.simple().textContent('Ya existe una descripción en este idioma').position('top right')
                                .theme('error').hideDelay(3000));
                        $scope.dataLoading = false;
                        return;
                    } else {
                        Object.defineProperty(copy.description, $scope.lang,
                                Object.getOwnPropertyDescriptor(copy.description, lang));
                        delete copy.description[lang];
                    }
                }

                copy.description[$scope.lang] = $scope.description;

                var jsonObj = angular.toJson(copy);

                ApiService.updateCode(code.idCode, jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent('Code modificado correctamente').position('top right')
                            .theme('success').hideDelay(3000));

                    vm.CargarCajeros();
                    $scope.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al guardar').position('top right')
                            .theme('error').hideDelay(5000));
                    $scope.dataLoading = false;
                });
            };
        }

        $scope.eliminarDescCode = function (code, lang) {
            var confirm = $mdDialog.confirm()
                    .title("¿Eliminar descripción '" + lang.toUpperCase() + "'?")
                    .ok('Eliminar')
                    .cancel('Cerrar');

            $mdDialog.show(confirm).then(function () {
                var copy = {
                    idCode: code.idCode,
                    description: angular.copy(code.description)
                };

                delete copy.description[lang];

                var jsonObj = angular.toJson(copy);

                ApiService.updateCode(code.idCode, jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent('Code modificado correctamente').position('top right')
                            .theme('success').hideDelay(3000));

                    vm.CargarCajeros();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al guardar').position('top right')
                            .theme('error').hideDelay(5000));
                    $scope.dataLoading = false;
                });
            });
        };

        //Eventos de scroll
        $('#content').ready(function () {
            $('#content').bind('scroll', chk_top);
        });

        function chk_top(e) {
            var elem = $(e.currentTarget);
            $rootScope.showGoToUpButton = (elem.scrollTop() > 0);
            $rootScope.$apply();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseTheming', fuseThemingProvider);

    /** @ngInject */
    function fuseThemingProvider()
    {
        // Inject Cookies Service
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        var registeredPalettes,
            registeredThemes;

        // Methods
        this.setRegisteredPalettes = setRegisteredPalettes;
        this.setRegisteredThemes = setRegisteredThemes;

        //////////

        /**
         * Set registered palettes
         *
         * @param _registeredPalettes
         */
        function setRegisteredPalettes(_registeredPalettes)
        {
            registeredPalettes = _registeredPalettes;
        }

        /**
         * Set registered themes
         *
         * @param _registeredThemes
         */
        function setRegisteredThemes(_registeredThemes)
        {
            registeredThemes = _registeredThemes;
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getRegisteredPalettes: getRegisteredPalettes,
                getRegisteredThemes  : getRegisteredThemes,
                setActiveTheme       : setActiveTheme,
                setThemesList        : setThemesList,
                themes               : {
                    list  : {},
                    active: {
                        'name' : '',
                        'theme': {}
                    }
                }
            };

            return service;

            //////////

            /**
             * Get registered palettes
             *
             * @returns {*}
             */
            function getRegisteredPalettes()
            {
                return registeredPalettes;
            }

            /**
             * Get registered themes
             *
             * @returns {*}
             */
            function getRegisteredThemes()
            {
                return registeredThemes;
            }

            /**
             * Set active theme
             *
             * @param themeName
             */
            function setActiveTheme(themeName)
            {
                // If theme does not exist, fallback to the default theme
                if ( angular.isUndefined(service.themes.list[themeName]) )
                {
                    // If there is no theme called "default"...
                    if ( angular.isUndefined(service.themes.list.default) )
                    {
                        $log.error('You must have at least one theme named "default"');
                        return;
                    }

                    $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                    // Otherwise set theme to default theme
                    service.themes.active.name = 'default';
                    service.themes.active.theme = service.themes.list.default;
                    $cookies.put('selectedTheme', service.themes.active.name);

                    return;
                }

                service.themes.active.name = themeName;
                service.themes.active.theme = service.themes.list[themeName];
                $cookies.put('selectedTheme', themeName);
            }

            /**
             * Set available themes list
             *
             * @param themeList
             */
            function setThemesList(themeList)
            {
                service.themes.list = themeList;
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes, fuseThemingProvider)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });

        // Store generated PALETTES and THEMES objects from $mdThemingProvider
        // in our custom provider, so we can inject them into other areas
        fuseThemingProvider.setRegisteredPalettes($mdThemingProvider._PALETTES);
        fuseThemingProvider.setRegisteredThemes($mdThemingProvider._THEMES);
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        'default': {
            "primary": {
                "name": "my-dark-blue",
                "hues": {"default": "700","hue-1": "500","hue-2": "600","hue-3": "400"}
            },
            "accent": {
                "name": "my-red",
                "hues": {"default": "600","hue-1": "400","hue-2": "700","hue-3": "A100"}
            },
            "warn": {
                "name": "my-blue",
                "hues": {"default": "500","hue-1": "300","hue-2": "800","hue-3": "A100"}
            },
            "background": {
                "name": "grey",
                "hues": {"default": "A100","hue-1": "A100","hue-2": "100","hue-3": "300"}
            }
        }
    };

    angular
            .module('app.core')
            .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-pale-blue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'my-dark-blue',
            options: {
                '50': '#072756',
                '100': '#072756',
                '200': '#072756',
                '300': '#072756',
                '400': '#072756',
                '500': '#072756',
                '600': '#072756',
                '700': '#072756',
                '800': '#072756',
                '900': '#072756',
                'A100': '#072756',
                'A200': '#072756',
                'A400': '#072756',
                'A700': '#072756',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'my-red',
            options: {
                '50': '#c33737',
                '100': '#c33737',
                '200': '#c33737',
                '300': '#c33737',
                '400': '#c33737',
                '500': '#c33737',
                '600': '#c33737',
                '700': '#c33737',
                '800': '#c33737',
                '900': '#c33737',
                'A100': '#c33737',
                'A200': '#c33737',
                'A400': '#c33737',
                'A700': '#c33737',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'my-blue',
            options: {
                '50': '#3b7bf0',
                '100': '#3b7bf0',
                '200': '#3b7bf0',
                '300': '#3b7bf0',
                '400': '#3b7bf0',
                '500': '#3b7bf0',
                '600': '#3b7bf0',
                '700': '#3b7bf0',
                '800': '#3b7bf0',
                '900': '#3b7bf0',
                'A100': '#3b7bf0',
                'A200': '#3b7bf0',
                'A400': '#3b7bf0',
                'A700': '#3b7bf0',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
            .module('app.core')
            .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming, customThemes)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba: rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            var registeredThemes = fuseTheming.getRegisteredThemes();
            var registeredPalettes = fuseTheming.getRegisteredPalettes();

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name': colorType.name,
                        'levels': {
                            'default': {
                                'color': rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1': {
                                'color': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2': {
                                'color': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3': {
                                'color': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            fuseTheming.setActiveTheme(customThemes.selectedTheme);
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if (color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255)
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if (contrastLevel)
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if (color.length === 3)
            {
                return 'rgb(' + color.join(',') + ')';
            } else if (color.length === 4)
            {
                return 'rgba(' + color.join(',') + ')';
            } else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if (color[0] === 255 && color[1] === 255 && color[2] === 255)
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if (color[0] === 0 && color[1] === 0, color[2] === 0)
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // Set active theme
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions()
    {
        return {
            restrict   : 'E',
            scope      : {
                panelOpen: '=?'
            },
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        backdropEl = angular.element('<div class="ms-theme-options-backdrop"></div>');

                    // Panel open status
                    scope.panelOpen = scope.panelOpen || false;

                    /**
                     * Toggle options panel
                     */
                    function toggleOptionsPanel()
                    {
                        if ( scope.panelOpen )
                        {
                            closeOptionsPanel();
                        }
                        else
                        {
                            openOptionsPanel();
                        }
                    }

                    function openOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = true;

                        // Add open class
                        iElement.addClass('open');

                        // Append the backdrop
                        bodyEl.append(backdropEl);

                        // Register the event
                        backdropEl.on('click touch', closeOptionsPanel);
                    }

                    /**
                     * Close options panel
                     */
                    function closeOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = false;

                        // Remove open class
                        iElement.removeClass('open');

                        // De-register the event
                        backdropEl.off('click touch', closeOptionsPanel);

                        // Remove the backdrop
                        backdropEl.remove();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsPanel = toggleOptionsPanel;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject required services
        var $log = angular.injector(['ng']).get('$log'),
            $resource = angular.injector(['ngResource']).get('$resource');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Prepare the resource object
            var resourceObj = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };

            // Assign the resource
            api[key] = $resource(resourceObj.url, resourceObj.paramDefaults, resourceObj.actions, resourceObj.options);
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($q, $log)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'EA',
            compile : function (tElement, tAttrs)
            {
                var code;
                //No attribute? code is the content
                if ( !tAttrs.code )
                {
                    code = tElement.html();
                    tElement.empty();
                }

                return function (scope, iElement, iAttrs)
                {
                    if ( iAttrs.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(iAttrs.code);
                    }
                    var shouldInterpolate = scope.$eval(iAttrs.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }

                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );

                            iElement.append(contentParent);

                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {
                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);

                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(iAttrs.language || iAttrs.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.toolbar')
            .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $mdSidenav, $scope, $cookies, $location, $mdDialog, ApiService, configInstalacion)
    {
        var vm = this;
        $scope.tituloVentana = configInstalacion.tituloVentana;

        $scope.logout = function () {
            $cookies.remove('user');
            $cookies.remove('role');
            $location.path('/login');
        };

        vm.toggleSidenav = function (sidenavId) {
            $mdSidenav(sidenavId).toggle();
        };

        vm.toggleHorizontalMobileMenu = function ()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.navigation')
            .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope, $rootScope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }
})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
            .module('fuse', [
                'app.core',
                'app.navigation',
                'app.toolbar',
                'app.error.e404',
                'app.error.e500',
                'app.login',
                'app.usuarios',
                'app.places',
                'app.cajeros'
            ]);
})();
(function ()
{
    'use strict';

    angular
            .module('fuse')
            .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, customThemes, fuseThemes)
    {
        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if (event.targetScope.$id === $scope.$id)
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });

        $scope.goUp = function () {
            $("#content").animate({scrollTop: 0}, 500);
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, $translateProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        // toastr configuration
        toastr.options.timeOut = 3000;
        toastr.options.positionClass = 'toast-top-right';
        toastr.options.preventDuplicates = true;
        toastr.options.progressBar = true;

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('es');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
            .module('fuse')
            .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, fuseTheming, $cookies, ApiService, $location)
    {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
            $rootScope.showGoToUpButton = false;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });

        ApiService.getUsuarios().then(function (dataResponse) {
            for (var i = 0; i < dataResponse.data.length; i++) {
                if (dataResponse.data[i].idUser === parseInt($cookies.get('user'))) {
                    $rootScope.user = dataResponse.data[i];
//                    console.info('run', $rootScope.user);

                    return;
                }
            }
            //Si hace el for y no encuentra un usuario -> Login
            $cookies.remove('user');
            $location.path('/login');
        });

        $rootScope.$on('$locationChangeStart', function () {
            var restrictedPage = ($location.path() !== '/login');
            var loggedIn = $cookies.get('user');

            if (restrictedPage && !loggedIn) {
                $location.path('/login');
                return;
            }
        });

        $rootScope.$watch('user', function () {
            if ($rootScope.user) {
                console.info('Logueado el usuario "' + $rootScope.user.name + '" con rol "' + $rootScope.user.userRole + '"');
            }
        }, true);

//        console.log('Lista de temas', angular.toJson(Object.keys(fuseTheming.getRegisteredThemes())));
    }
})();
(function ()
{
    'use strict';

    angular
            .module('fuse')
            .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/error404');

        // State definitions
        $stateProvider
                .state('app', {
                    abstract: true,
                    views: {
                        'main@': {
                            templateUrl: 'app/core/layouts/horizontal-navigation.html',
                            controller: 'MainController as vm'
                        },
                        'toolbar@app': {
                            templateUrl: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                            controller: 'ToolbarController as vm'
                        },
                        'navigation@app': {
                            templateUrl: 'app/navigation/layouts/horizontal-navigation/navigation.html',
                            controller: 'NavigationController as vm'
                        }
                    }
                });
    }

})();

(function ()
{
    'use strict';

    angular
            .module('fuse')
            .filter('userByName', userByName)
            .filter('trustHtml', trustHtml);

    function userByName() {
        return function (input, list) {
            if (list) {
                var arr = list.filter(function (us) {
                    return us.name === input;
                });
                return arr[0] ? arr[0] : {name: input};
            }
        };
    }

    function trustHtml($sce) {
        return function (html) {
            return $sce.trustAsHtml(html);
        };
    }
})();

(function ()
{
    'use strict';

    angular
            .module('fuse')
            .directive('onLastRepeat', OnLastRepeat)
            .directive('ngRightClick', ngRightClick)
            .directive('onErrorImage', onErrorImage)
            .directive('fileModel', fileModel);

    function OnLastRepeat() {
        return function (scope, element, attrs) {
            if (scope.$last || (scope[attrs.onLastRepeat] && scope[attrs.onLastRepeat].length === 0))
                setTimeout(function () {
                    scope.$emit('onRepeatLast', element, attrs);
                }, 1000);
        };
    }

    function ngRightClick($parse) {
        return function (scope, element, attrs) {
            var fn = $parse(attrs.ngRightClick);
            element.bind('contextmenu', function (event) {
                scope.$apply(function () {
                    event.preventDefault();
                    fn(scope, {$event: event});
                });
            });
        };
    }

    function onErrorImage() {
        return function (scope, iElement, iAttrs) {
            iElement.bind('error', function () {
                angular.element(this).attr("src", iAttrs.onErrorImage || "/assets/resources/img-error.png");
            });
        };
    }

    function fileModel($parse, $q) {
        return {
            restrict: "A",
            link: function (scope, element, attrs) {
                var model = $parse(attrs.fileModel),
                        modelSetter = model.assign;
                element.bind("change", function () {
                    scope.$apply(function () {
                        var file = element[0].files[0];
                        getFileBuffer(file).then(function (resp) {
                            modelSetter(scope, resp);
                        });
                    });
                });
            }
        };
        function getFileBuffer(file) {
            var deferred = new $q.defer();
            var reader = new FileReader();
            reader.onloadend = function (e) {
                deferred.resolve(e.target.result);
            };
            reader.onerror = function (e) {
                deferred.reject(e.target.error);
            };
            reader.readAsDataURL(file);
            return deferred.promise;
        }
    }

})();
(function ()
{
    'use strict';

    angular
            .module('fuse')
            .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming, msNavigationService, $rootScope)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
        //////////
    }
})();
(function ()
{
    'use strict';

    var configInstalacion = {
        "tituloVentana": "Gestor de cajeros",
        "baseUrl": "https://api.atms.solertia-hospitality.com"
    };

    var customThemes = {
        "selectedTheme": "default",
        "availableThemes": ["default"]
    };

    angular
            .module('fuse')
            .constant('configInstalacion', configInstalacion)
            .constant('customThemes', customThemes);

})();

(function ()
{
    'use strict';

    angular
            .module('fuse')
            .config(config);

    /** @ngInject */
    function config(configInstalacion, $mdDateLocaleProvider)
    {
        document.title = configInstalacion.tituloVentana;

        //Configuración para los calendarios
        $mdDateLocaleProvider.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        $mdDateLocaleProvider.shortMonths = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
        $mdDateLocaleProvider.days = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sábado'];
        $mdDateLocaleProvider.shortDays = ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'];
        $mdDateLocaleProvider.firstDayOfWeek = 1;

        $mdDateLocaleProvider.formatDate = function (date) {
            return moment(date).format('DD/MM/YYYY');
        };
    }

})();
(function ()
{
    'use strict';

    angular
            .module('fuse')
            .service('ApiService', ApiService);

    function ApiService($http, configInstalacion) {

        var api = this;

        api.baseUrl = configInstalacion.baseUrl;

        //************ USUARIOS ***************
        this.getUsuarios = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/users'
            });
        };

        this.addUsuario = function (jsonObj) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/users',
                data: jsonObj
            });
        };

        this.loginUsuario = function (jsonObj) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/users/login',
                data: jsonObj
            });
        };

        this.deleteUsuario = function (id) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/users/' + id
            });
        };

        this.updateUsuario = function (idUser, jsonObj) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/users/' + idUser,
                data: jsonObj
            });
        };

        this.updatePasswordUsuario = function (idUser, oldPass, newPass) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/users/' + idUser + '/password',
                params: {
                    oldpassword: oldPass,
                    newpassword: newPass
                }
            });
        };

        this.getUsuario = function (name) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/users/' + name
            });
        };

        //************** Places ******************
        this.getPlaces = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/places'
            });
        };

        this.addPlace = function (jsonObj) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/places',
                data: jsonObj
            });
        };

        this.obtainInstallationsExternal = function (domain) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/places/installation/external'
            });
        };

        this.getPlace = function (domain) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/places/place',
                params: {dominio: domain}
            });
        };

        this.syncPlace = function (place) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/places/transmit',
                params: {
                    nameId: place
                }
            });
        };

        this.deletePlace = function (idPlace) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/places/' + idPlace
            });
        };

        this.updatePlace = function (idPlace, jsonObj) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/places/' + idPlace,
                data: jsonObj
            });
        };

        this.syncPlaceExtern = function (place) {
            return $http({
                method: 'GET',
                url: 'https://' + place + '.solertia.sol:8443/Solertia/atm/update/atms'
            });
        };

        //************** Cajeros ******************
        this.getCajeros = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/atms'
            });
        };

        this.addCajero = function (jsonObj) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/atms',
                data: jsonObj
            });
        };

        this.getTeamCajeros = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/atms/teams'
            });
        };

        this.getCajerosPorTeam = function (team) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/atms/teams/search',
                params: {
                    team: team
                }
            });
        };

        this.getCajero = function (id) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/atms/uuid/' + id
            });
        };

        this.deleteCajero = function (idAtm) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/atms/' + idAtm
            });
        };

        this.updateCajero = function (idAtm, jsonObj) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/atms/' + idAtm,
                data: jsonObj
            });
        };

        //********************* Archivos ***********************
        this.uploadFile = function (formData, fileName, folder) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/files/media',
                data: formData,
                headers: {'Content-Type': undefined},
                params: {
                    fileName: fileName,
                    folder: folder
                },
                transformRequest: angular.identity
            });
        };

        this.getFiles = function (folder) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/files/media',
                headers: {'Content-Type': 'application/json'},
                params: {
                    folder: folder || ''
                }
            });
        };

        this.deleteFile = function (fileName, folder) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/files/media/' + fileName,
                headers: {'Content-Type': 'application/json'},
                params: {
                    folder: folder
                }
            });
        };
        
        //******************* Codes de cajeros ********************
        this.getCodes = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/codes'
            });
        };

        this.addCode = function (jsonObj) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/codes',
                data: jsonObj
            });
        };

        this.getCode = function (id) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/codes/uuid/' + id
            });
        };

        this.deleteCode = function (idCode) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/codes/' + idCode
            });
        };

        this.updateCode = function (idCode, jsonObj) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/codes/' + idCode,
                data: jsonObj
            });
        };

    }
})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar\" ui-view=\"toolbar\"></md-toolbar><div id=\"horizontal-navigation\" class=\"md-whiteframe-1dp\" \nui-view=\"navigation\"></div><div id=\"content-container\" flex layout=\"column\"><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1 _background_\" ms-scroll ui-view=\"content\" flex></md-content></div>\n<md-button class=\"md-fab md-mini md-primary go-up-button\" ng-click=\"goUp()\" ng-show=\"showGoToUpButton\" \nid=\"go-up-button\"><md-icon md-font-icon=\"icon-chevron-up\"></md-icon></md-button></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-panel\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"ms-theme-options-panel-button md-primary-bg\" ng-click=\"toggleOptionsPanel()\"><md-icon \nmd-font-icon=\"icon-palette\" class=\"white-text\"></md-icon></div><div class=\"ms-theme-options-list\" layout=\"column\"><div \nclass=\"theme-option\"><div class=\"option-title\">Color Palette:</div><md-menu-item \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"theme\"><md-button class=\"md-raised theme-button\" \naria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"themeName\"><span><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" md-font-icon=\"icon-palette\">\n</md-icon><span>{{themeName}}</span></span></md-button></md-menu-item></div></div></div>");
$templateCache.put("app/main/cajeros/cajeros.html","<div id=\"cajeros\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding layout=\"column\" \nmd-whiteframe=\"1\"><div layout=\"row\" layout-align=\"start center\" flex><md-button class=\"md-fab md-mini\" \nng-click=\"addCajero()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"bottom\">\nRegistrar nuevo cajero</md-tooltip></md-button><md-button class=\"md-fab md-mini\" ng-click=\"vm.CargarCajeros()\"><md-icon\n md-font-icon=\"icon-refresh\"></md-icon><md-tooltip md-direction=\"bottom\">Recargar datos</md-tooltip></md-button><span \nflex></span><md-checkbox ng-model=\"showExtendedInfo\">Mostrar + info</md-checkbox></div><div \nng-repeat=\"team in vm.listaCajeros|orderBy: \'name\' track by $index\" class=\"team-container\"><div flex=\"100\" \nclass=\"title md-accent-bg\">{{team.name}}</div><div ng-repeat=\"cajero in team.atms|orderBy:\'model\' track by $index\" \nflex ng-class=\"{\'extended\': showExtendedInfo}\"><md-list-item class=\"cajero md-primary-bg md-3-line layout-wrap\"><div \nclass=\"md-list-item-text\" flex><h3><span class=\"cyan-fg\">Nombre:</span> {{cajero.model}}<span ng-if=\"cajero.phone\" \nclass=\"phone\"> · {{cajero.phone}}</span></h3><h4><span class=\"cyan-fg\">IP:</span> {{cajero.ip}} <span class=\"cyan-fg\">\n- MAC:</span> {{cajero.mac|uppercase}}</h4><h4><span class=\"cyan-fg\">Versión:</span> {{cajero.version}} <span \nclass=\"cyan-fg\">- Tipo:</span> {{cajero.type}} <span class=\"cyan-fg\">- Chats:</span> {{cajero.chats.length}}</h4><h4>\n<span class=\"cyan-fg\">Metálico:</span> <span style=\"color: {{cajero.metallic ? \'limegreen\' : \'red\'}}\">\n{{cajero.metallic ? \'Si\' : \'No\'}}</span> <span class=\"cyan-fg\">- Tarjeta:</span> <span \nstyle=\"color: {{cajero.creditcard ? \'limegreen\' : \'red\'}}\">{{cajero.creditcard ? \'Si\' : \'No\'}}</span></h4></div><div \nlayout=\"row\" class=\"features\"><md-icon md-font-icon=\"icon-sync\" class=\"green-fg\" ng-show=\"cajero.synchronizeDatabase\">\n<md-tooltip md-direction=\"top\">Sincronización activa</md-tooltip></md-icon><md-icon md-font-icon=\"icon-sync-off\" \nclass=\"red-fg\" ng-show=\"!cajero.synchronizeDatabase\"><md-tooltip md-direction=\"top\">Sincronización desactivada\n</md-tooltip></md-icon><md-icon md-font-icon=\"{{featureIcons[e].icon|| \'icon-help\'}}\" \nng-repeat=\"e in cajero.features track by $index\" class=\"yellow-fg\"><md-tooltip md-direction=\"top\">\n{{featureIcons[e].text|| e}}</md-tooltip></md-icon></div><div layout=\"row\" layout-align=\"end\" class=\"margin-left-25\">\n<md-button class=\"md-fab md-warn md-mini\" ng-click=\"asignarTeam(cajero)\"><md-icon md-font-icon=\"icon-group\"></md-icon>\n<md-tooltip md-direction=\"bottom\">Asignar grupo</md-tooltip></md-button><md-button class=\"md-fab md-warn md-mini\" \nng-click=\"editarConfig(cajero)\"><md-icon md-font-icon=\"icon-code-braces\"></md-icon><md-tooltip md-direction=\"bottom\">\nEditar objeto config</md-tooltip></md-button><md-button class=\"md-fab md-warn md-mini\" ng-click=\"editarCajero(cajero)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip md-direction=\"bottom\">Editar cajero</md-tooltip></md-button>\n<md-button class=\"md-fab md-warn md-mini\" ng-click=\"eliminarCajero(cajero)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><md-tooltip md-direction=\"bottom\">Eliminar cajero</md-tooltip></md-button></div></md-list-item><md-list-item \nclass=\"info md-primary-bg\" ng-show=\"showExtendedInfo\" layout=\"column\"><h3>Descripción general</h3><table><tr><th>Idioma\n</th><th>Descripción</th><th></th></tr><tr ng-repeat=\"lang in objectKeys(cajero.description) track by $index\"><td>\n{{lang}}</td><td class=\"html-container\"><ng-template ng-bind-html=\"cajero.description[lang] | trustHtml\"></ng-template>\n</td><td><div layout=\"row\" layout-align=\"center\"><md-button class=\"md-icon-button md-accent md-mini\" \nng-click=\"editarDescCajero(cajero, lang)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip \nmd-direction=\"bottom\">Editar descripción</md-tooltip></md-button><md-button class=\"md-icon-button md-accent md-mini\" \nng-click=\"eliminarDescCajero(cajero, lang)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip \nmd-direction=\"bottom\">Eliminar descripción</md-tooltip></md-button></div></td></tr><tr><td colspan=\"3\"><md-button \nclass=\"md-icon-button md-mini md-accent\" ng-click=\"addDescCajero(cajero)\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip md-direction=\"bottom\">Registrar nueva descripción</md-tooltip></md-button></td></tr></table><h3>\nCódigos de composición de nº de habitación</h3><table><tr><th>Nombre</th><th>Descripción</th><th>Posibilidades</th><th>\nImagen</th><th></th></tr><tr ng-repeat=\"code in cajero.codes track by $index\"><td class=\"inner-table\"><table><tr \nng-repeat=\"lang in objectKeys(code.name) track by $index\"><td>{{lang}}</td><td>{{code.name[lang]}}</td><td><div \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button md-accent md-mini\" \nng-click=\"editarNameCode(code, lang)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip md-direction=\"bottom\">\nEditar nombre</md-tooltip></md-button><md-button class=\"md-icon-button md-accent md-mini\" \nng-click=\"eliminarNameCode(code, lang)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip \nmd-direction=\"bottom\">Eliminar nombre</md-tooltip></md-button></div></td></tr><tr><td colspan=\"3\"><md-button \nclass=\"md-icon-button md-mini md-accent\" ng-click=\"addNameCode(code)\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip md-direction=\"bottom\">Añadir nombre</md-tooltip></md-button></td></tr></table></td><td class=\"inner-table\">\n<table><tr ng-repeat=\"lang in objectKeys(code.description) track by $index\"><td>{{lang}}</td><td>\n{{code.description[lang]}}</td><td><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button md-accent md-mini\" ng-click=\"editarDescCode(code, lang)\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon><md-tooltip md-direction=\"bottom\">Editar descripción</md-tooltip></md-button><md-button \nclass=\"md-icon-button md-accent md-mini\" ng-click=\"eliminarDescCode(code, lang)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><md-tooltip md-direction=\"bottom\">Eliminar descripción</md-tooltip></md-button></div></td></tr><tr><td \ncolspan=\"3\"><md-button class=\"md-icon-button md-mini md-accent\" ng-click=\"addDescCode(code)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"bottom\">Añadir descripción</md-tooltip></md-button></td>\n</tr></table></td><td>{{code.posibilities}}</td><td><img ng-src=\"{{code.imagen}}\" width=\"80\" height=\"80\"></td><td><div \nlayout=\"row\" layout-align=\"center\"><md-button class=\"md-icon-button md-accent md-mini\" \nng-click=\"editarCode(cajero, code)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip md-direction=\"bottom\">\nEditar code</md-tooltip></md-button><md-button class=\"md-icon-button md-accent md-mini\" \nng-click=\"eliminarCode(cajero, code)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip md-direction=\"bottom\">\nEliminar code</md-tooltip></md-button></div></td></tr><tr><td colspan=\"5\"><md-button \nclass=\"md-icon-button md-mini md-accent\" ng-click=\"addCode(cajero)\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip md-direction=\"bottom\">Añadir code</md-tooltip></md-button></td></tr></table></md-list-item></div></div>\n</md-content></div></div>");
$templateCache.put("app/main/places/places.html","<div id=\"places\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding layout=\"column\" \nmd-whiteframe=\"1\"><div layout=\"row\" layout-align=\"start center\" flex><md-button class=\"md-fab md-mini\" \nng-click=\"addPlace()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"bottom\">\nRegistrar nueva instalación</md-tooltip></md-button><md-button class=\"md-fab md-mini\" ng-click=\"vm.CargarPlaces()\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip md-direction=\"bottom\">Recargar datos</md-tooltip>\n</md-button><span flex></span><md-button class=\"md-fab md-mini md-warn\" ng-click=\"vm.SincronizarPendientes()\"><md-icon \nmd-font-icon=\"icon-sync-alert\"></md-icon><md-tooltip md-direction=\"left\">Sincronizar instalaciones desactualizadas\n</md-tooltip></md-button></div><div layout=\"row\" layout-wrap><div \nng-repeat=\"place in vm.listaPlaces|orderBy:\'name\' track by place.idPlace\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"33\" \nflex-gt-lg=\"25\"><md-list-item class=\"place md-primary-bg\"><div class=\"indicador\"><md-icon md-font-icon=\"icon-sync\" \nng-if=\"place.synchronized\"><md-tooltip md-direction=\"right\" class=\"md-green-800-bg font-size-12\">\nSincronizado (Últ. sinc: {{place.lastSyncFormat}})</md-tooltip></md-icon><md-icon md-font-icon=\"icon-sync-alert\" \nng-if=\"!place.synchronized\"><md-tooltip md-direction=\"right\" class=\"md-red-700-bg font-size-12\">\nNo sincronizado (Últ. sinc: {{place.lastSyncFormat}})</md-tooltip></md-icon></div><div class=\"md-list-item-text\" flex>\n<h3>{{place.name}}</h3><h4>{{place.dominio}}<span class=\"md-warn-fg\">.solertia.sol</span></h4><span \nclass=\"grey-500-fg\">Últ. mod: {{place.lastModifiedFormat}}</span></div><md-fab-speed-dial md-direction=\"left\" \nclass=\"md-scale layout-align-start-start\"><md-fab-trigger><md-button aria-label=\"menu\" class=\"md-fab md-warn md-mini\">\n<md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></md-fab-trigger><md-fab-actions layout-wrap><md-button \nclass=\"md-fab md-mini md-warn\" ng-click=\"eliminarPlace(place)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n<md-tooltip md-direction=\"bottom\">Eliminar instalación</md-tooltip></md-button><md-button \nclass=\"md-fab md-mini md-warn\" ng-click=\"editarPlace(place)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip \nmd-direction=\"bottom\">Editar instalación</md-tooltip></md-button><md-button class=\"md-fab md-mini md-warn\" \nng-click=\"verUsuarios(place)\"><md-icon md-font-icon=\"icon-deskphone\"></md-icon><md-tooltip md-direction=\"bottom\">\nVer cajeros</md-tooltip></md-button><md-button class=\"md-fab md-mini md-accent\" ng-click=\"sincronizar(place)\"><md-icon \nmd-font-icon=\"icon-sync\"></md-icon><md-tooltip md-direction=\"bottom\">Sincronizar con la instalación</md-tooltip>\n</md-button></md-fab-actions></md-fab-speed-dial></md-list-item></div></div></md-content></div></div>");
$templateCache.put("app/main/usuarios/usuarios.html","<div id=\"usuarios\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\" md-whiteframe=\"1\"><div layout=\"row\" layout-align=\"start center\" flex><md-button class=\"md-fab md-mini\" \nng-click=\"vm.CargarUsuarios()\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip md-direction=\"bottom\">\nRecargar datos</md-tooltip></md-button></div><div layout=\"row\" layout-wrap><div \nng-repeat=\"usuario in vm.listaUsuarios|orderBy:\'name\' track by usuario.idUser\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-sm=\"33\" flex-gt-lg=\"25\"><md-list-item layout=\"row\" class=\"usuario md-primary-bg\"><img ng-src=\"{{usuario.img}}\" \nsrc=\"/assets/resources/user.png\" class=\"md-avatar\" alt=\"{{usuario.img}}\" on-error-image=\"/assets/resources/user.png\">\n<div class=\"md-list-item-text layout-row\" flex><h3>{{usuario.name}}</h3></div></md-list-item></div></div></md-content>\n</div></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Row Color\" md-menu-origin \nng-click=\"$mdOpenMenu($event)\" ng-class=\"selectedColor.class\"><span ng-show=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-show=\"!selectedColor.palette\">Select Color</span>\n</md-button><md-menu-content class=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-if=\"!selectedColor.palette\">Select Color</span>\n<md-button class=\"remove-color-button md-icon-button\" ng-click=\"removeColor()\" aria-label=\"Remove Color\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-if=\"!selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in palettes\" ng-click=\"activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-if=\"selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+selectedPalette+\'-\'+hue+\'-bg\'\" \nng-repeat=\"(hue, values) in selectedHues\" ng-click=\"selectColor(selectedPalette,hue)\" layout=\"row\" \nlayout-align=\"start end\" md-ink-ripple><span class=\"label\">{{hue}} </span><i \nng-if=\"selectedPalette == selectedColor.palette && hue == selectedColor.hue\" class=\"s16 icon-check\"></i></div></div>\n</div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><md-icon \nid=\"ms-search-bar-collapser\" md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></label><input \nid=\"ms-search-bar-input\" type=\"text\" ng-model=\"global.search\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div>");
$templateCache.put("app/main/auth/login/login.html","<div id=\"quantionLogin\" class=\"flex-scrollable\" layout=\"column\" ms-scroll \nstyle=\"background: url(/assets/wallpaper.png) no-repeat; background-size: cover\"><div id=\"login-form-wrapper\" \nlayout=\"row\" layout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo_ md-accent-bg\"><img src=\"assets/logo-blanco.png\" alt=\"\"></div><div class=\"title\">Accede a tu cuenta</div>\n<form name=\"loginForm\" novalidate><md-input-container class=\"md-block no-errors-spacer\"><label>Usuario</label><input \ntype=\"text\" name=\"usuario\" ng-model=\"vm.user.name\" required autofocus></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\"><label>Contraseña</label><input type=\"password\" name=\"password\" \nng-model=\"vm.user.password\" required></md-input-container><div style=\"color: red; text-align: center\">\n{{vm.mensajeError}}</div><div style=\"color: #01cd3e; text-align: center\" ng-show=\"vm.loggedSuccesfully\">Entrando...\n</div><img ng-show=\"vm.dataLoading\" src=\"/assets/resources/cargando.gif\"><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"Entrar\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \nng-click=\"vm.login()\">Entrar</md-button></form></div></div></div>");
$templateCache.put("app/main/cajeros/templates/asignarTeam.tmpl.html","<md-dialog id=\"editarCajero\" aria-label=\"Crear/editar cajero\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 flex>\n{{DialogTitle}}</h2><md-button class=\"md-icon-button\" aria-label=\"cerrar\" ng-click=\"hide()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form name=\"form\" novalidate \nlayout=\"column\"><md-input-container><label>Grupo</label><md-select ng-model=\"cajero.team\"><md-option \nng-repeat=\"team in teamList|orderBy\" value=\"{{team}}\">{{team}}</md-option><md-option value=\"___\"><em>- Otro -</em>\n</md-option></md-select></md-input-container><md-input-container ng-show=\"cajero.team === \'___\'\"><label>\nNuevo nombre de grupo</label><input ng-model=\"customTeam\" ng-required=\"cajero.team === \'___\'\"></md-input-container>\n</form></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/resources/cargando.gif\"><md-button ng-click=\"hide()\">Cerrar</md-button><md-button ng-click=\"Guardar()\" \nng-disabled=\"form.$invalid\" style=\"margin-right:20px\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cajeros/templates/cambiarConfig.tmpl.html","<md-dialog id=\"editarCajero\" aria-label=\"Crear/editar cajero\" flex flex-xs=\"100\" flex-xs=\"100\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 flex>{{DialogTitle}}</h2><md-button class=\"md-icon-button\" aria-label=\"cerrar\" \nng-click=\"hide()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form \nname=\"form\" novalidate layout=\"column\"><md-input-container><label>Config</label><textarea ng-model=\"cajero.config\" \nrows=\"10\"></textarea></md-input-container><md-button class=\"md-warn md-raised\" ng-click=\"formatJson()\">Dar formato\n</md-button></form></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/resources/cargando.gif\"><md-button ng-click=\"hide()\">Cerrar</md-button><md-button ng-click=\"Guardar()\" \nng-disabled=\"form.$invalid\" style=\"margin-right:20px\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cajeros/templates/codeCajero.tmpl.html","<md-dialog id=\"codeCajero\" aria-label=\"Crear/editar cajero\" flex flex-xs=\"100\" flex-sm=\"100\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 flex>{{DialogTitle}}</h2><md-button class=\"md-icon-button\" aria-label=\"cerrar\" \nng-click=\"hide()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nlayout=\"column\"><form name=\"Form\" novalidate><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-wrap \nlayout-align=\"space-between start\" class=\"container\"><md-input-container class=\"md-block\" flex flex-gt-xs=\"50\"><label>\nATM</label><input name=\"atm\" ng-model=\"code.atm\" required><div ng-messages=\"Form.atm.$error\" multiple=\"multiple\" \nmd-auto-hide=\"false\"><div ng-message=\"required\">Este campo es obligatorio.</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex flex-gt-xs=\"50\"><label>Instalación</label><input name=\"installation\" \nng-model=\"code.installation\" required><div ng-messages=\"Form.installation.$error\" multiple=\"multiple\" \nmd-auto-hide=\"false\"><div ng-message=\"required\">Este campo es obligatorio.</div></div></md-input-container><md-checkbox\n ng-model=\"code.checklist\" aria-label=\"\" flex flex-gt-xs=\"30\">Comprobar posibilidades</md-checkbox></div><div \nlayout=\"column\"><label>Posibilidades</label><md-chips name=\"posibilities\" ng-model=\"code.posibilities\" \nplaceholder=\"Nuevo carácter\"><md-chip-template><strong>{{$chip}}</strong></md-chip-template></md-chips></div><div \nlayout=\"row\" layout-align=\"start center\" class=\"file-upload-container\"><div layout=\"column\"><img \nng-src=\"{{code.imagen}}\" ng-if=\"!!code.imagen\"><md-button class=\"md-raised md-accent\" ng-click=\"code.imagen = null\" \nng-if=\"!!code.imagen\">Eliminar imagen</md-button></div><input type=\"file\" id=\"fileSelector1\" class=\"form-control\" \nname=\"schemeupload\" accept=\"image/*\" file-model=\"code.imagen\"></div></form></md-dialog-content><md-dialog-actions \nlayout=\"row\"><img ng-if=\"dataLoading\" src=\"/assets/resources/cargando.gif\"><md-button ng-click=\"hide()\">Cerrar\n</md-button><md-button ng-click=\"Guardar()\" ng-disabled=\"form.$invalid\" style=\"margin-right:20px\">Guardar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cajeros/templates/crearCajero.tmpl.html","<md-dialog id=\"editarCajero\" aria-label=\"Crear/editar cajero\" flex flex-xs=\"100\" flex-sm=\"100\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 flex>{{DialogTitle}}</h2><md-button class=\"md-icon-button\" aria-label=\"cerrar\" \nng-click=\"hide()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nlayout=\"column\"><form name=\"Form\" novalidate><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-wrap \nlayout-align=\"space-between start\" class=\"container\"><md-input-container class=\"md-block\" flex flex-gt-xs=\"30\"><label>\nNombre</label><input name=\"model\" ng-model=\"cajero.model\" required><div ng-messages=\"Form.model.$error\" \nmultiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\">Este campo es obligatorio.</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex flex-gt-xs=\"30\"><label>IP</label><input name=\"ip\" \nng-model=\"cajero.ip\" required><div ng-messages=\"Form.ip.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\">Este campo es obligatorio.</div></div></md-input-container><md-input-container class=\"md-block\" \nflex flex-gt-xs=\"30\"><label>MAC</label><input name=\"mac\" ng-model=\"cajero.mac\" required><div \nng-messages=\"Form.mac.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\">\nEste campo es obligatorio.</div></div></md-input-container><md-input-container class=\"md-block\" flex flex-gt-xs=\"30\">\n<label>Port</label><input name=\"port\" ng-model=\"cajero.port\" required><div ng-messages=\"Form.port.$error\" \nmultiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\">Este campo es obligatorio.</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex flex-gt-xs=\"30\"><label>Puerto API</label><input \nname=\"directPort\" ng-model=\"cajero.directPort\" required><div ng-messages=\"Form.directPort.$error\" multiple=\"multiple\" \nmd-auto-hide=\"false\"><div ng-message=\"required\">Este campo es obligatorio.</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex flex-gt-xs=\"30\"><label>Teléfono de contacto</label><input name=\"phone\" \nng-model=\"cajero.phone\" required><div ng-messages=\"Form.phone.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\">Este campo es obligatorio.</div></div></md-input-container><md-input-container class=\"md-block\" \nflex flex-gt-xs=\"30\"><label>Versión</label><input name=\"version\" ng-model=\"cajero.version\" required><div \nng-messages=\"Form.version.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\">\nEste campo es obligatorio.</div></div></md-input-container><md-input-container class=\"md-block\" flex flex-gt-xs=\"30\">\n<label>Tipo</label><md-select ng-model=\"cajero.type\" name=\"type\" required><md-option></md-option><md-option \nng-repeat=\"t in [\'card\', \'code\', \'sumup\']\" value=\"{{t}}\">{{t}}</md-option></md-select><div \nng-messages=\"Form.type.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\">\nEste campo es obligatorio.</div></div></md-input-container><md-checkbox ng-model=\"cajero.synchronizeDatabase\" \naria-label=\"Sync Database\" flex flex-gt-xs=\"30\">Sincronizar BBDD</md-checkbox><md-checkbox ng-model=\"cajero.metallic\" \naria-label=\"Metalico\" flex flex-gt-xs=\"30\">Acepta metálico</md-checkbox><md-checkbox ng-model=\"cajero.creditcard\" \naria-label=\"Tarjeta de credito\" flex flex-gt-xs=\"30\">Acepta tarjeta de crédito</md-checkbox><span flex flex-gt-xs=\"30\">\n</span></div><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-wrap layout-align=\"space-between start\" \nclass=\"margin-top-15\"><md-input-container class=\"md-block no-errors-spacer\" flex flex-gt-xs=\"30\"><label>\nNº digitos (bloque)</label><input type=\"number\" name=\"block\" ng-model=\"cajero.block\" min=\"0\" required><div \nng-messages=\"Form.block.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\">\nEste campo es obligatorio.</div></div></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex \nflex-gt-xs=\"30\"><label>Nº digitos (nº hab.)</label><input type=\"number\" name=\"room\" ng-model=\"cajero.room\" min=\"0\" \nrequired><div ng-messages=\"Form.room.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\">\nEste campo es obligatorio.</div></div></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex \nflex-gt-xs=\"30\"><label>Nº digitos (cama)</label><input type=\"number\" name=\"bed\" ng-model=\"cajero.bed\" min=\"0\" required>\n<div ng-messages=\"Form.bed.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\">\nEste campo es obligatorio.</div></div></md-input-container></div><div layout=\"column\"><label>Features</label><md-chips \nname=\"features\" ng-model=\"cajero.features\" placeholder=\"Nueva feature\"><md-chip-template><strong>{{$chip}}</strong>\n</md-chip-template></md-chips><div class=\"hint\">Ej: InzRfid, InzCash, InzCard, InzRc, SpecialCard</div></div><div \nlayout=\"column\" class=\"margin-top-15\"><label>Chat ID de Mattermost</label><md-chips name=\"chats\" \nng-model=\"cajero.chats\" placeholder=\"Nueva ID de chat\"><md-chip-template><strong>{{$chip}}</strong></md-chip-template>\n</md-chips></div><div style=\"color: red; text-align: center; margin-top: 20px\">{{mensajeError}}</div></form>\n</md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" src=\"/assets/resources/cargando.gif\">\n<md-button ng-click=\"hide()\">Cerrar</md-button><md-button ng-click=\"Guardar()\" ng-disabled=\"Form.$invalid\" \nstyle=\"margin-right:20px\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cajeros/templates/descCajero.tmpl.html","<md-dialog id=\"descCajero\" aria-label=\"Descripcion cajero\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 flex>\n{{DialogTitle}}</h2><md-button class=\"md-icon-button\" aria-label=\"cerrar\" ng-click=\"hide()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form name=\"form\" novalidate \nlayout=\"column\"><md-input-container><label>Idioma</label><input ng-model=\"lang\" required></md-input-container>\n<md-input-container><label>Descripción</label><textarea ng-model=\"description\" required></textarea>\n</md-input-container></form><ng-template ng-bind-html=\"description | trustHtml\"></ng-template></md-dialog-content>\n<md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" src=\"/assets/resources/cargando.gif\"><md-button \nng-click=\"hide()\">Cerrar</md-button><md-button ng-click=\"Guardar()\" ng-disabled=\"form.$invalid\" \nstyle=\"margin-right:20px\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cajeros/templates/descCode.tmpl.html","<md-dialog id=\"descCode\" aria-label=\"Descripcion code\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 flex>\n{{DialogTitle}}</h2><md-button class=\"md-icon-button\" aria-label=\"cerrar\" ng-click=\"hide()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form name=\"form\" novalidate \nlayout=\"column\"><md-input-container><label>Idioma</label><input ng-model=\"lang\" required></md-input-container>\n<md-input-container><label>Descripción</label><textarea ng-model=\"description\" required></textarea>\n</md-input-container></form></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/resources/cargando.gif\"><md-button ng-click=\"hide()\">Cerrar</md-button><md-button ng-click=\"Guardar()\" \nng-disabled=\"form.$invalid\" style=\"margin-right:20px\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/places/templates/crearPlace.tmpl.html","<md-dialog id=\"editarPlace\" aria-label=\"Crear/editar place\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 flex>\n{{DialogTitle}}</h2><md-button class=\"md-icon-button\" aria-label=\"cerrar\" ng-click=\"hide()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form name=\"form\" \nlayout=\"column\" ng-submit=\"Guardar()\"><md-input-container class=\"md-block no-errors-spacer\" flex><label>Nombre</label>\n<input ng-model=\"place.name\" required></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex>\n<label>Dominio (*.solertia.sol)</label><input ng-model=\"place.dominio\" required></md-input-container></form>\n</md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" src=\"/assets/resources/cargando.gif\">\n<md-button ng-click=\"hide()\">Cerrar</md-button><md-button ng-click=\"Guardar()\" ng-disabled=\"form.$invalid\" \nstyle=\"margin-right:20px\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/places/templates/syncProgress.tmpl.html","<md-dialog id=\"ver-usuarios\" aria-label=\"Crear/editar usuario\"><md-dialog-content><div layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"inst in pendientes\"><p flex style=\"margin: 6px 0\">{{inst.name}}</p><img \nng-if=\"!loaded[inst.dominio] && !notloaded[inst.dominio]\" src=\"/assets/resources/cargando.gif\"><md-icon \nmd-font-icon=\"icon-check\" style=\"color: limegreen\" ng-if=\"loaded[inst.dominio]\"></md-icon><md-icon \nmd-font-icon=\"icon-close\" style=\"color: red\" ng-if=\"notloaded[inst.dominio]\"></md-icon></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/places/templates/verUsuarios.tmpl.html","<md-dialog id=\"cajeros\" aria-label=\"Crear/editar usuario\" flex flex-xs=\"100\" flex-sm=\"100\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 flex>{{place.name}}</h2><md-button class=\"md-icon-button\" aria-label=\"cerrar\" \nng-click=\"hide()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content>\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"36\" style=\"margin: auto\" ng-show=\"loading\">\n</md-progress-circular><div ng-repeat=\"team in listaCajeros|orderBy: \'name\' track by $index\" class=\"team-container\">\n<div flex=\"100\" class=\"title md-accent-bg\">{{team.name}}</div><div \nng-repeat=\"cajero in team.atms|orderBy:\'model\' track by $index\" flex><md-list-item \nclass=\"cajero md-primary-bg md-3-line\"><md-checkbox class=\"md-warn\" ng-checked=\"exists(cajero.idAtm, place.atms)\" \nng-click=\"toggle(cajero.idAtm, place.atms)\" aria-label=\"aaa\"></md-checkbox><div class=\"md-list-item-text\" flex><h3>\n<span class=\"cyan-fg\">Nombre:</span> {{cajero.model}}<span ng-if=\"cajero.phone\" class=\"phone\"> · {{cajero.phone}}\n</span></h3><h4><span class=\"cyan-fg\">IP:</span> {{cajero.ip}} <span class=\"cyan-fg\">- MAC:</span>\n {{cajero.mac|uppercase}}</h4><h4><span class=\"cyan-fg\">Versión:</span> {{cajero.version}} <span class=\"cyan-fg\">\n- Tipo:</span> {{cajero.type}}</h4></div></md-list-item></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><img ng-if=\"dataLoading\" src=\"/assets/resources/cargando.gif\"><md-button ng-click=\"hide()\">Cerrar\n</md-button><md-button ng-click=\"Guardar()\" ng-disabled=\"form.$invalid\" style=\"margin-right:20px\">Guardar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/usuarios/templates/crearUsuario.tmpl.html","<md-dialog id=\"editarUsuario\" aria-label=\"Crear/editar usuario\" flex flex-xs=\"100\" flex-sm=\"100\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 flex>Crear usuario</h2><md-button class=\"md-icon-button\" aria-label=\"cerrar\" \nng-click=\"hide()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form \nname=\"form\" layout=\"column\" ng-submit=\"Guardar()\"><div class=\"md-block layout-row layout-align-center\"><label \nfor=\"uploadImage\" class=\"image-container\" style=\"margin-bottom: 8px\"><img id=\"uploadPreview\" \nsrc=\"assets/resources/user.png\" style=\"max-width: 100px; max-height: 100px\"><div class=\"tooltip\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon></div></label><input id=\"uploadImage\" type=\"file\" name=\"myPhoto\" hidden \naccept=\"image/*\"></div><div class=\"layout-row\"><md-icon md-font-icon=\"icon-star\" ng-click=\"toggleStar()\" \nng-class=\"{\'star-active\':usuario.userRole === \'ROOT\'}\"></md-icon><md-input-container class=\"md-block no-errors-spacer\" \nflex><label>Nombre</label><input ng-model=\"usuario.name\" required></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex><label>Contraseña</label><input type=\"password\" ng-model=\"usuario.password\" \nrequired></md-input-container></div><div class=\"layout-row layout-wrap\"><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\" flex-xs=\"50\" flex-sm=\"50\"><label>Teléfono</label><input \nng-model=\"usuario.phone\"></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex=\"25\" \nflex-xs=\"50\" flex-sm=\"50\"><label>Email</label><input ng-model=\"usuario.mail\"></md-input-container><md-input-container \nflex=\"25\" flex-xs=\"50\" flex-sm=\"50\"><label>Departamento</label><md-select ng-model=\"usuario.team\"><md-option \nng-repeat=\"team in listaTeams\" value=\"{{team}}\">{{team}}</md-option></md-select></md-input-container>\n<md-input-container flex=\"25\" flex-xs=\"50\" flex-sm=\"50\"><label>Idioma</label><md-select ng-model=\"usuario.language\">\n<md-option ng-repeat=\"lang in listaLang\" value=\"{{lang}}\"><img ng-src=\"/assets/flags/{{lang}}.png\" \nstyle=\"max-height:24px\"></md-option></md-select></md-input-container></div><div \nclass=\"layout-row layout-wrap layout-align-start-center\"><md-input-container class=\"md-block no-errors-spacer\" flex>\n<label>UUID de tarjeta</label><input ng-model=\"usuario.uuid\"></md-input-container><md-checkbox \nng-model=\"usuario.enabled\" flex style=\"margin-left: 15px\">Activo</md-checkbox></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span style=\"color: red\" flex>{{error}}</span> <img ng-if=\"dataLoading\" \nsrc=\"/assets/resources/cargando.gif\"><md-button ng-click=\"hide()\">Cerrar</md-button><md-button ng-click=\"Guardar()\" \nng-disabled=\"form.$invalid\" style=\"margin-right:20px\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/usuarios/templates/editarUsuario.tmpl.html","<md-dialog id=\"editarUsuario\" aria-label=\"Crear/editar usuario\" ng-cloak flex flex-xs=\"100\" flex-sm=\"100\"><md-toolbar>\n<div class=\"md-toolbar-tools\"><h2 flex>Editar usuario</h2><md-button class=\"md-icon-button\" aria-label=\"cerrar\" \nng-click=\"hide()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form \nname=\"form\" layout=\"column\" ng-submit=\"Guardar()\"><div class=\"md-block layout-row layout-align-center\"><label \nfor=\"uploadImage\" class=\"image-container\" style=\"margin-bottom: 8px\"><img id=\"uploadPreview\" ng-src=\"{{usuario.img}}\" \nsrc=\"assets/resources/user.png\" style=\"max-width: 100px; max-height: 100px\"><div class=\"tooltip\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon></div></label><input id=\"uploadImage\" type=\"file\" name=\"myPhoto\" hidden \naccept=\"image/*\"></div><div class=\"layout-row\"><md-icon md-font-icon=\"icon-star\" ng-click=\"toggleStar()\" \nng-class=\"{\'star-active\':usuario.userRole === \'ROOT\'}\"></md-icon><md-input-container class=\"md-block no-errors-spacer\" \nflex><label>Nombre</label><input ng-model=\"usuario.name\" required></md-input-container></div><md-checkbox \nng-model=\"changePass\" class=\"margin-top-25\" ng-init=\"password = {}\">Cambiar contraseña</md-checkbox><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-block margin-0\" flex flex-xs=\"100\" ng-if=\"changePass\"><label>\nContraseña actual</label><input type=\"password\" ng-model=\"password.old\" required></md-input-container>\n<md-input-container class=\"md-block margin-0\" flex flex-xs=\"100\" ng-if=\"changePass\"><label>Nueva contraseña</label>\n<input type=\"password\" ng-model=\"password.new1\" required></md-input-container><md-input-container \nclass=\"md-block margin-0\" flex flex-xs=\"100\" ng-if=\"changePass\"><label>Repetir nueva contraseña</label><input \ntype=\"password\" ng-model=\"password.new2\" required></md-input-container></div><div class=\"layout-row layout-wrap\">\n<md-input-container class=\"md-block no-errors-spacer\" flex=\"25\" flex-xs=\"50\" flex-sm=\"50\"><label>Teléfono</label><input\n ng-model=\"usuario.phone\"></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex=\"25\" \nflex-xs=\"50\" flex-sm=\"50\"><label>Email</label><input ng-model=\"usuario.mail\"></md-input-container><md-input-container \nflex=\"25\" flex-xs=\"50\" flex-sm=\"50\"><label>Departamento</label><md-select ng-model=\"usuario.team\"><md-option \nng-repeat=\"team in listaTeams\" value=\"{{team}}\">{{team}}</md-option></md-select></md-input-container>\n<md-input-container flex=\"25\" flex-xs=\"50\" flex-sm=\"50\"><label>Idioma</label><md-select ng-model=\"usuario.language\">\n<md-option ng-repeat=\"lang in listaLang\" value=\"{{lang}}\"><img ng-src=\"/assets/flags/{{lang}}.png\" \nstyle=\"max-height:24px\"></md-option></md-select></md-input-container></div><div \nclass=\"layout-row layout-wrap layout-align-start-center\"><md-input-container class=\"md-block no-errors-spacer\" flex>\n<label>UUID de tarjeta</label><input ng-model=\"usuario.uuid\"></md-input-container><md-checkbox \nng-model=\"usuario.enabled\" flex style=\"margin-left: 15px\">Activo</md-checkbox></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span style=\"color: red\" flex>{{error}}</span> <img ng-if=\"dataLoading\" \nsrc=\"/assets/resources/cargando.gif\"><md-button ng-click=\"hide()\">Cerrar</md-button><md-button ng-click=\"Guardar()\" \nng-disabled=\"form.$invalid\" style=\"margin-right:20px\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/usuarios/templates/rolesUsuario.tmpl.html","<md-dialog id=\"rolesUsuario\" aria-label=\"Roles usuario\" flex flex-xs=\"100\" flex-sm=\"100\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 flex>Editar roles</h2><md-button class=\"md-icon-button\" aria-label=\"cerrar\" \nng-click=\"hide()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nlayout=\"row\" layout-align=\"start center\" class=\"margin-bottom-24\"><span>Cambiar todos a:</span><md-select \nng-model=\"asdf\" class=\"margin-8\" aria-label=\"set all\" flex flex-gt-xs=\"30\"><md-option ng-repeat=\"role in listaRoles\" \nng-value=\"role.idRol\">{{role.name}}</md-option></md-select><md-button class=\"md-icon-button\" aria-label=\"More\" \nng-click=\"setAll(asdf)\"><md-icon md-font-icon=\"icon-arrow-right\"></md-icon></md-button></div><div layout=\"row\" \nlayout-wrap flex><div ng-repeat=\"place in listaPlaces\" layout=\"row\" layout-align=\"start center\" \nclass=\"md-yellow-400-bg margin-right-5 margin-bottom-5 flex-xs-100 flex-sm-45 flex-30\" \nstyle=\"border: 1px solid lightgray;padding: 0 8px;border-radius: 0.5em\"><span flex=\"30\">{{place.name}}</span><md-select\n ng-model=\"mapRole[place.idPlace]\" class=\"margin-8\" flex aria-label=\".\"><md-option ng-value=\"-1\"></md-option><md-option\n ng-repeat=\"role in listaRoles\" ng-value=\"role.idRol\">{{role.name}}</md-option></md-select></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span style=\"color: red\" flex>{{error}}</span> <img \nng-if=\"dataLoading\" src=\"/assets/resources/cargando.gif\"><md-button ng-click=\"hide()\">Cerrar</md-button><md-button \nng-click=\"Guardar()\" ng-disabled=\"form.$invalid\" style=\"margin-right:20px\">Guardar</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/usuarios/templates/verUsuario.tmpl.html","<md-dialog id=\"verUsuario\" aria-label=\"Crear/editar usuario\" flex flex-xs=\"100\" flex-sm=\"100\"><md-toolbar><div \nclass=\"md-toolbar-tools layout-row layout-align-end-center\"><md-button class=\"md-icon-button\" aria-label=\"cerrar\" \nng-click=\"hide()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"layout-row layout-xs-column layout-align-xs-center-center margin-bottom-24\"><div class=\"image\"><img \nng-src=\"{{usuario.img}}\" src=\"/assets/resources/user.png\" on-error-image=\"/assets/resources/user.png\"></div><div \nclass=\"layout-column layout-align-start-start\"><span class=\"md-headline\">{{::usuario.name}}</span> <span \nclass=\"md-subhead\"><md-icon md-font-icon=\"icon-phone\" class=\"margin-right-5\"></md-icon>{{::usuario.phone|| \'-\'}}</span>\n <span class=\"md-subhead\"><md-icon md-font-icon=\"icon-email\" class=\"margin-right-5\"></md-icon>{{::usuario.mail|| \'-\'}}\n</span> <span class=\"md-subhead\"><md-icon md-font-icon=\"icon-credit-card\" class=\"margin-right-5\"></md-icon>\nUUID: {{::usuario.uuid|| \'-\'}}</span></div></div><md-divider></md-divider><p>\nÚltima modificación: {{usuario.lastModified}}</p></md-dialog-content></md-dialog>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE\n</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm \nng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" \nms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/changeUser.tmpl.html","<md-dialog id=\"editarUsuario\" aria-label=\"Crear/editar usuario\" ng-cloak flex flex-xs=\"100\" flex-sm=\"100\"><md-toolbar>\n<div class=\"md-toolbar-tools\"><h2 flex>{{DialogTitle}}</h2><md-button class=\"md-icon-button\" aria-label=\"cerrar\" \nng-click=\"hide()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form \nname=\"form\" layout=\"column\" ng-submit=\"Guardar()\"><md-input-container class=\"md-block no-errors-spacer\" flex><label>\nNombre</label><input ng-model=\"usuario.name\" required></md-input-container><md-checkbox ng-model=\"changePass\" \nclass=\"margin-top-25\" ng-init=\"password = {}\">Cambiar contraseña</md-checkbox><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-block margin-0 margin-top-15 no-errors-spacer\" flex flex-xs=\"100\" ng-if=\"changePass\">\n<label>Contraseña actual</label><input type=\"password\" ng-model=\"password.old\" required></md-input-container>\n<md-input-container class=\"md-block margin-0 margin-top-15 no-errors-spacer\" flex flex-xs=\"100\" ng-if=\"changePass\">\n<label>Nueva contraseña</label><input type=\"password\" ng-model=\"password.new1\" required></md-input-container>\n<md-input-container class=\"md-block margin-0 margin-top-15 no-errors-spacer\" flex flex-xs=\"100\" ng-if=\"changePass\">\n<label>Repetir nueva contraseña</label><input type=\"password\" ng-model=\"password.new2\" required></md-input-container>\n</div></form></md-dialog-content><md-dialog-actions layout=\"row\"><span style=\"color: red\" flex>{{error}}</span> <img \nng-if=\"dataLoading\" src=\"/assets/resources/cargando.gif\"><md-button ng-click=\"hide()\">Cerrar</md-button><md-button \nng-click=\"Guardar()\" ng-disabled=\"form.$invalid\" style=\"margin-right:20px\">Guardar</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image md-accent-bg\"><md-icon md-font-icon=\"icon-deskphone\" \nclass=\"md-accent-bg\"></md-icon></span><span class=\"logo-text\" hide-xs>{{tituloVentana}}</span></div></div>\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress || $root.loadingRequest\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div layout=\"row\"><md-button id=\"quick-panel-toggle\" \nclass=\"md-icon-button\" ng-click=\"logout()\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon></md-button>\n</div></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress || $root.loadingRequest\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\">\n<div class=\"toolbar-separator\"></div><ms-search-bar></ms-search-bar><div class=\"toolbar-separator\"></div><md-menu-bar \nid=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" \nmd-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress || $root.loadingRequest\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\">\n</md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-xs>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-backburger\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\" hide-gt-sm></i>\n            <i class=\"icon-chevron-down s18 arrow\" ng-if=\"vm.hasChildren\" hide show-gt-sm></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\" hide-gt-sm></i>\n            <i class=\"icon-chevron-down s18 arrow\" ng-if=\"vm.hasChildren\" hide show-gt-sm></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/auth/errores/404/error-404.html","<div id=\"error404\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"row\" \nlayout-align=\"center center\"><div><img src=\"/assets/resources/error404.png\"></div><div layout=\"column\"><div \nclass=\"error-code\" flex=\"50\">404</div><div class=\"message\" flex=\"50\">Página no encontrada</div></div></div><div>\n<md-button class=\"md-raised md-primary\" ng-click=\"goHome()\">Volver a Inicio</md-button></div></div>");
$templateCache.put("app/main/auth/errores/500/error-500.html","<div id=\"error500\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"row\" \nlayout-align=\"center center\"><div><img src=\"/assets/resources/error500.png\"></div><div flex=\"5\"></div><div \nlayout=\"column\"><div class=\"error-code\" flex=\"50\">500</div><div class=\"message\" flex=\"50\">Error interno del servidor\n</div></div></div><div class=\"buttons\" layout=\"column\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-primary\" ng-click=\"goHome()\" ng-disabled=\"tryingReturn\">Volver a Inicio</md-button><span \nng-show=\"tryingReturn\"><img src=\"/assets/resources/cargando.gif\">Conectando...</span> <span ng-show=\"error\" \nstyle=\"color: red\">No se puede establecer la conexión. Vuelva a intentarlo más tarde</span></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps\" layout=\"row\" layout-align=\"start center\"><div class=\"step md-accent-bg\" \nlayout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{step.stepNumber}} \n</span><span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\">\n</span></div><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");}]);